import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { increment, decrement } from "../../Redux/Action/Action";
import ContactModal from "../model/ContactModal";
import Slider from "react-slick";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../../context/AppContext";
import { Link } from "react-router-dom";
// import { MetaTags } from "react-meta-tags";
import MarketingBanImg from "../../assets/images/marketing-ban.jpg";
import { Helmet } from "react-helmet";

function Marketing() {
  const { subActive, setSubActive } = useUserAuth();
  const [commonModal, setCommonModal] = useState(false);
  const dispatch = useDispatch();
  const naviagte = useNavigate();
  const routePath = useLocation();
  const location = useLocation();
  const path = location.pathname;
  const scrollToRef = useRef();
  const accuratePath = routePath.pathname;

  useEffect(() => {
    if (accuratePath === "/digital-marketing") {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    }

    if (
      accuratePath === "/digital-marketing/search-engine-optimization" ||
      accuratePath === "/seo-services" ||
      accuratePath === "/digital-marketing" ||
      accuratePath === "/digital-marketing/social-media-management" ||
      accuratePath === "/digital-marketing/paid-marketing" ||
      accuratePath === "/digital-marketing/app-store-optimization" ||
      accuratePath === "/app-store-optimization" ||
      accuratePath === "/digital-marketing/content-marketing" ||
      accuratePath === "/content-writing-services" ||
      accuratePath === "/digital-marketing/email-marketing" ||
      accuratePath === "/email-marketing-services" ||
      accuratePath === "/digital-marketing/digital-branding" ||
      accuratePath === "/digital-marketing/analytics-and-reporting"
    ) {
      setSubActive(0);
    } else if (
      accuratePath ===
      "/digital-marketing/search-engine-optimization/on-page-SEO" ||
      accuratePath ===
      "/digital-marketing/social-media-management/facebook-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/search-engine-marketing-services" ||
      accuratePath ===
      "/digital-marketing/content-marketing/web-page-writing" ||
      accuratePath === "/digital-marketing/email-marketing/email-writing"
    ) {
      setSubActive(1);
    } else if (
      accuratePath ===
      "/digital-marketing/search-engine-optimization/off-page-SEO" ||
      accuratePath ===
      "/digital-marketing/social-media-management/instagram-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/google-ad-services" ||
      accuratePath === "/digital-marketing/content-marketing/blog-writing" ||
      accuratePath ===
      "/digital-marketing/email-marketing/email-automation-service"
    ) {
      setSubActive(2);
    } else if (
      accuratePath ===
      "/digital-marketing/social-media-management/twitter-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/bing-ad-services" ||
      accuratePath === "/digital-marketing/content-marketing/article-writing" ||
      accuratePath ===
      "/digital-marketing/email-marketing/email-list-building-services"
    ) {
      setSubActive(3);
    } else if (
      accuratePath ===
      "/digital-marketing/social-media-management/linkedIn-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/facebook-ads-services" ||
      accuratePath ===
      "/digital-marketing/content-marketing/guest-post-writing" ||
      accuratePath ===
      "/digital-marketing/email-marketing/email-campaign-setup-and-management"
    ) {
      setSubActive(4);
    } else if (
      accuratePath ===
      "/digital-marketing/social-media-management/pinterest-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/instagram-ads-services" ||
      accuratePath ===
      "/digital-marketing/content-marketing/social-media-post-writing"
    ) {
      setSubActive(5);
    } else if (
      accuratePath ===
      "/digital-marketing/social-media-management/youTube-marketing" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/twitter-ads-services" ||
      accuratePath === "/twitter-ads" ||
      accuratePath === "/digital-marketing/content-marketing/proofread"
    ) {
      setSubActive(6);
    } else if (
      accuratePath ===
      "/digital-marketing/paid-marketing-services/LinkedIn-ads-services"
    ) {
      setSubActive(7);
    } else if (
      accuratePath ===
      "/digital-marketing/paid-marketing-services/pinterest-ads-services"
    ) {
      setSubActive(8);
    } else if (
      accuratePath === "/youtube-ads" ||
      accuratePath ===
      "/digital-marketing/paid-marketing-services/youTube-ads-services"
    ) {
      setSubActive(9);
    }
    // eslint-disable-next-line
  }, [accuratePath]);

  useEffect(() => {
    var count = 0;
    var path = routePath.pathname;
    for (var i = 0; i < path.length; i++) {
      if (path[i] === "/") {
        count++;
      }
    }
    if (count > 1) {
      scrollToRef.current.scrollIntoView();
    }
  }, [routePath, subActive]);

  const settings = {
    prevArrow: (
      <button
        type="button"
        className="slick-prev"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Previous
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Next
      </button>
    ),
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>

      {/* <MetaTags>
        <meta
          id="meta-description"
          name="description"
          content="Maximize your online presence with Kindlebit, offering professional SEO services, social media management, paid marketing, and more. Join us!"
        />
      </MetaTags> */}
      <Helmet>
        <title>Digital Marketing services & SEO | Internet Marketing</title>
        <meta
          name="keyword"
          content="digital marketing services, search engine positioning seo, internet marketing service, search engine optimization services"
        />
        <meta
          name="description"
          content="Drive more leads and sales with our full internet marketing service, where we manage all digital marketing services and search engine optimization services."
        />
      </Helmet>

      <main className="inner-page" id="services-Marketing">
        <section className="banner dark">
          <img className="banner-img" src={MarketingBanImg} alt="..." />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">Marketing</div>
              <div className="text-para">
                We combine innovation and technology to revolutionise your
                digital marketing initiatives and produce marketing assets that
                captivate prospects. We have a proven track record of designing
                effective strategies that will scale your business profitably.
              </div>
            </div>
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="sap-card-inner container">
            <div className="sec-heading">
              <div className="sap-caption-head">
                <div className="sap-caption">what our services say</div>
              </div>
              <div ref={scrollToRef} className="sap-lg-heading">
                Our services
                <br />
                that we provide
              </div>
            </div>

            <Slider
              {...settings}
              className="services-slider owl-carousel owl-theme"
            >
              <Link to="/digital-marketing/search-engine-optimization">
                <div
                  className={
                    accuratePath === "/digital-marketing" ||
                      accuratePath ===
                      "/digital-marketing/search-engine-optimization" ||
                      accuratePath === "/seo-services" ||
                      accuratePath ===
                      "/digital-marketing/search-engine-optimization/on-page-SEO" ||
                      accuratePath ===
                      "/digital-marketing/search-engine-optimization/off-page-SEO"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="1"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="300"
                      height="300"
                      viewBox="0 0 300 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_24"
                        data-name="Group 24"
                        transform="translate(-9992.164 -7991.326)"
                      >
                        <path
                          id="Path_138"
                          data-name="Path 138"
                          d="M9994.84,8291.326a2.724,2.724,0,0,1,0-5.447h4.679a2.124,2.124,0,0,0,2.122-2.123v-42.538a21.7,21.7,0,0,1,43.391,0V8283.6a2.124,2.124,0,0,0,2.122,2.122h18.761a2.124,2.124,0,0,0,2.123-2.122v-89.781a21.747,21.747,0,0,1,43.493,0v89.722a2.125,2.125,0,0,0,2.122,2.122h18.862a2.125,2.125,0,0,0,2.122-2.122V8155.715a21.693,21.693,0,0,1,43.387,0v127.868a2.124,2.124,0,0,0,2.121,2.122h18.863a2.125,2.125,0,0,0,2.122-2.122V8160.432a7.461,7.461,0,0,1,7.454-7.454,2.125,2.125,0,0,0,2.123-2.123l.006-4.253c.01-5.137.021-9.988-.1-14.915-.051-2.04-2.531-3.356-3.655-3.642-17.37-4.424-31.193-13.928-41.089-28.249a67.226,67.226,0,0,1-6.909-64.766,70.714,70.714,0,0,1,52.408-42.742c1.04-.2,2.076-.418,3.11-.638.513-.109,1.022-.218,1.535-.324h13.683l.139.056a6.613,6.613,0,0,0,1.617.473c28.731,3.732,51.153,23.446,58.518,51.449.615,2.338,1.1,4.788,1.562,7.156.208,1.063.416,2.126.637,3.186v13.7l-.064.181c-.151.424-.3.851-.419,1.285-.561,2.081-1.048,4.213-1.518,6.274a72.239,72.239,0,0,1-3.728,12.748c-8.991,20.739-24.961,34.262-47.465,40.193-.946.249-3.662,1.442-3.715,3.569-.126,4.947-.117,9.816-.106,14.973l.006,4.211a2.125,2.125,0,0,0,2.122,2.123,7.464,7.464,0,0,1,7.455,7.454v123.4a2.124,2.124,0,0,0,2.121,2.123h42.587a2.724,2.724,0,1,1,0,5.447Zm95.092-113.819a16.1,16.1,0,0,0-16.083,16.082v92.243h32.164v-92.243A16.1,16.1,0,0,0,10089.932,8177.507Zm-66.591,47.458a16.124,16.124,0,0,0-16.105,16.105v44.606h32.212V8241.07A16.125,16.125,0,0,0,10023.341,8224.965Zm133.1-85.537a16.128,16.128,0,0,0-16.111,16.11v130.116h32.222V8155.538A16.128,16.128,0,0,0,10156.443,8139.428Zm58.019,19a7.621,7.621,0,0,0-7.612,7.613v119.61h32.211V8166.317a7.9,7.9,0,0,0-7.892-7.891Zm1.837-5.711h13.381v-28.741c14.212-1.785,26.012-7.108,36.021-16.238a64.667,64.667,0,0,0,16.511-23.842,63.674,63.674,0,0,0,3.861-32.3c-4.045-30-29.336-53.035-60.137-54.776-1.119-.063-2.257-.095-3.38-.095a63.915,63.915,0,0,0-61.513,48.415c-3.647,15.085-2.115,29.534,4.555,42.944,10.159,20.424,27.211,32.531,50.7,36Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_139"
                          data-name="Path 139"
                          d="M10270.662,8158.3a2.724,2.724,0,0,1,0-5.448h18.778a2.724,2.724,0,0,1,0,5.448Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_140"
                          data-name="Path 140"
                          d="M10270.662,8177.307a2.724,2.724,0,0,1,0-5.448h18.778a2.724,2.724,0,0,1,0,5.448Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_141"
                          data-name="Path 141"
                          d="M10270.662,8196.31a2.723,2.723,0,1,1,0-5.447h18.778a2.723,2.723,0,1,1,0,5.447Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_142"
                          data-name="Path 142"
                          d="M10270.662,8215.314a2.724,2.724,0,0,1,0-5.448h18.778a2.724,2.724,0,0,1,0,5.448Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_143"
                          data-name="Path 143"
                          d="M10270.662,8234.317a2.724,2.724,0,0,1,0-5.448h18.778a2.724,2.724,0,0,1,0,5.448Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_144"
                          data-name="Path 144"
                          d="M10270.662,8253.32a2.724,2.724,0,0,1,0-5.447h18.778a2.724,2.724,0,1,1,0,5.447Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_145"
                          data-name="Path 145"
                          d="M10270.662,8272.324a2.724,2.724,0,0,1,0-5.448h18.778a2.724,2.724,0,0,1,0,5.448Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_146"
                          data-name="Path 146"
                          d="M9998.289,8203.271a1.176,1.176,0,0,1-.874-.385l-2.127-2.317a1.2,1.2,0,0,1,.076-1.69l5.981-5.531c5.84-5.4,11.6-10.727,17.369-16.049l5.666-5.23c9.644-8.9,19.614-18.112,29.483-27.1a7.3,7.3,0,0,1,3.888-1.543c5.334-.073,10.765-.074,16.018-.075,3.926,0,7.852,0,11.775-.03a6.814,6.814,0,0,0,4.6-1.527c10-9.885,19.776-19.673,30.131-30.035l5.46-5.464a2.874,2.874,0,0,0-2.026-4.908h-5.205a2.665,2.665,0,1,1,0-5.329h18.274a3.186,3.186,0,0,1,3.183,3.183v18.24a2.577,2.577,0,0,1-5.153,0V8112a2.863,2.863,0,0,0-2.861-2.859,2.829,2.829,0,0,0-2.014.839l-9.576,9.576c-9.019,9.023-18.344,18.354-27.578,27.463a7.308,7.308,0,0,1-4.049,1.705c-4.361.084-9.036.16-13.675.16-4.161,0-7.89-.061-11.4-.188-.206-.007-.408-.011-.608-.011-3.713,0-6.611,1.225-9.692,4.1-13.744,12.81-27.791,25.76-41.374,38.285l-12.874,11.873A1.2,1.2,0,0,1,9998.289,8203.271Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_147"
                          data-name="Path 147"
                          d="M10222.827,8110.779a49.692,49.692,0,0,1-35.408-14.635,50.339,50.339,0,0,1-14.71-35.913,49.355,49.355,0,0,1,14.774-35.355,50.749,50.749,0,0,1,35.883-14.535c27.518.047,49.811,22.637,49.783,50.357a50.285,50.285,0,0,1-50.306,50.081Zm.108-95.012a44.893,44.893,0,0,0-44.8,44.545,45.05,45.05,0,0,0,44.726,45.023,44.784,44.784,0,0,0,.134-89.568Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_148"
                          data-name="Path 148"
                          d="M10223.007,8086.878a2.728,2.728,0,0,1-2.724-2.724v-38.79l-3.463-1.388-6.344,6.666a2.373,2.373,0,0,1-3.4-3.309l14.881-14.718a1.37,1.37,0,0,1,1.938.006l15.057,15.053a2.324,2.324,0,0,1,.032,3.234,2.349,2.349,0,0,1-1.726.769,2.3,2.3,0,0,1-1.721-.761l-6.427-7.081-3.378,1.307v39.012A2.728,2.728,0,0,1,10223.007,8086.878Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Search engine optimization</div>
                </div>
              </Link>

              <Link to="/digital-marketing/social-media-management">
                <div
                  className={
                    accuratePath ===
                      "/digital-marketing/social-media-management" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/facebook-marketing" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/instagram-marketing" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/twitter-marketing" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/linkedIn-marketing" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/pinterest-marketing" ||
                      accuratePath ===
                      "/digital-marketing/social-media-management/youTube-marketing"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="2"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="300.05"
                      height="300"
                      viewBox="0 0 300.05 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_27"
                        data-name="Group 27"
                        transform="translate(-10632.995 -7991.326)"
                      >
                        <path
                          id="Path_161"
                          data-name="Path 161"
                          d="M10783.191,8291.326a21.138,21.138,0,0,1-20.422-15.779,20.611,20.611,0,0,1,12.768-24.5c3.552-1.28,4.862-3.25,4.52-6.8a50.421,50.421,0,0,1-.1-5.958c.021-.945.041-1.9.041-2.88v-1.418l-1.414-.094c-22.053-1.458-41.391-9.453-57.477-23.763l-1.073-.952-25.534,25.709.688,1.029a26.747,26.747,0,0,1,3.452,23.474,26.012,26.012,0,0,1-11.212,14.536,26.857,26.857,0,1,1-14.414-49.556,28.9,28.9,0,0,1,15.638,4.811l1.024.651,25.521-25.457-.952-1.069a92.941,92.941,0,0,1-23.792-57.5l-.092-1.417h-1.42q-1.488,0-2.971-.013c-1.01-.006-1.991-.012-2.972-.012-2.484,0-4.384.041-6.162.134-1.692.089-2.676,2.358-3.019,3.329a21.1,21.1,0,0,1-20.015,14.38c-.25,0-.5,0-.745-.012a21.285,21.285,0,0,1-19.264-15.179,20.879,20.879,0,0,1,13.589-25.567,21.133,21.133,0,0,1,6.619-1.069,20.5,20.5,0,0,1,19.331,13.577c1.091,3.081,2.784,4.4,5.662,4.4q.444,0,.942-.04c.979-.077,2.044-.112,3.346-.112.881,0,1.771.015,2.68.032.961.017,1.939.034,2.944.034h1.42l.092-1.418c1.428-21.99,9.37-41.271,23.6-57.305l.949-1.072-25.756-25.607-1.033.7a27.726,27.726,0,0,1-15.648,4.587q-.734,0-1.479-.034c-12.583-.562-23.259-11.029-24.834-24.345-1.414-11.948,7.373-25.1,18.8-28.146a5.757,5.757,0,0,1,1.463-.208,2.743,2.743,0,0,1,2.849,2.143c.189.625.768,2.528-2.8,3.861-8.918,3.324-14.589,11.184-14.448,20.024a21.074,21.074,0,0,0,14.765,19.811,20.9,20.9,0,0,0,19.463-36.114c-.209-.169-.425-.331-.639-.492-.256-.191-.5-.37-.72-.565-1.171-1.018-2.271-2.61-.865-4.419a2.571,2.571,0,0,1,2.1-1.132,4.537,4.537,0,0,1,2.441.877c11.255,7.444,14.633,23.394,7.531,35.559l-1.991,3.371,4.417,4.371c2.759,2.725,5.528,5.461,8.269,8.225,2.645,2.666,5.263,5.36,7.91,8.086l4.717,4.848,1.08-.96c16.763-14.865,35.736-22.785,58-24.213l1.418-.092v-1.42c0-.9,0-1.787.01-2.671l0-.366c.02-3.072.039-5.969-.118-8.933-.105-2-3.207-3.093-3.238-3.1a21.489,21.489,0,0,1-13.516-13.583,20.573,20.573,0,0,1,2.715-18.149,21.247,21.247,0,0,1,11.927-8.454,8.526,8.526,0,0,0,1.293-.522l.178-.082h7.652c.713.3,1.439.576,2.166.852a26.611,26.611,0,0,1,4.8,2.191c7.358,4.664,10.8,11.516,9.963,19.815-.866,8.535-5.607,14.546-14.093,17.862-.561.222-3.348,1.427-3.487,3.42-.2,2.855-.171,5.641-.144,8.592.009,1.04.02,2.067.02,3.1v1.411l1.405.1a97.546,97.546,0,0,1,31.01,7.051A95.74,95.74,0,0,1,10845,8072.4l1.068.941,25.519-25.492-.659-1.027c-9.074-14.159-4.023-29.2,5.655-36.732a26.966,26.966,0,0,1,16.5-5.632,26.848,26.848,0,0,1,22.771,41.026,26.02,26.02,0,0,1-14.432,11.344,28.393,28.393,0,0,1-8.631,1.393,26.689,26.689,0,0,1-15.046-4.745l-1.028-.688-25.785,25.457.954,1.074c14.338,16.148,22.342,35.506,23.789,57.539l.094,1.416h1.418c1.065,0,2.112-.012,3.148-.024s2.006-.022,2.975-.022c1.538,0,2.794.029,3.954.089.168.009.328.013.481.013,3.063,0,4.1-1.9,4.713-3.751a20.722,20.722,0,0,1,19.753-14.2h.169a21.017,21.017,0,0,1,19.7,14.581c.222.676.488,1.317.745,1.937l.228.553v7.7l-.228.555c-.264.634-.528,1.268-.748,1.935a21.011,21.011,0,0,1-19.427,14.576l-.388,0a20.644,20.644,0,0,1-19.679-13.965c-.928-2.768-2.434-3.948-5.029-3.948q-.311,0-.654.022c-1.088.068-2.265.1-3.7.1-.915,0-1.844-.013-2.791-.024-1.077-.015-2.127-.029-3.207-.029h-1.418l-.095,1.415c-1.445,22.029-9.46,41.378-23.815,57.508l-.953,1.07,25.664,25.556,1.031-.688a26.2,26.2,0,0,1,14.64-4.773c.594,0,1.2.023,1.81.07a39.481,39.481,0,0,1,7.787,1.426,4.13,4.13,0,0,1,2.629,1.779,2.834,2.834,0,0,1,.112,2.256,2.585,2.585,0,0,1-2.766,1.849,6.7,6.7,0,0,1-1.923-.315,24.175,24.175,0,0,0-7-1.066c-10.253,0-18.478,7.04-20.468,17.517a20.921,20.921,0,0,0,16.7,23.85,22.858,22.858,0,0,0,3.692.3c10.522,0,19.432-7.411,20.725-17.239a32.185,32.185,0,0,0-.427-9.183c-.6-3.758.616-4.438,1.8-4.779a3.785,3.785,0,0,1,1.021-.157c1.744,0,2.57,1.8,2.958,3.306,2.824,11.027-.021,20.3-8.459,27.551-5.212,4.48-10.895,6.752-16.89,6.752a27.557,27.557,0,0,1-11.559-2.713c-10.086-4.658-15.388-12.787-15.758-24.162a26.936,26.936,0,0,1,4.782-15.714l.672-1.029-25.579-25.57-1.067.947c-16.153,14.32-35.5,22.313-57.513,23.755l-1.417.094v1.42q0,1.329-.011,2.646l0,.37c-.019,2.909-.039,5.918.116,8.887.091,1.7,2.33,2.851,3.186,3.148,8.9,3.126,14.616,11,14.57,20.061a21.216,21.216,0,0,1-18.239,20.656,20.168,20.168,0,0,1-2.545.16Zm-.219-35.8a14.994,14.994,0,0,0-14.905,14.795,14.843,14.843,0,0,0,4.413,10.607,15.017,15.017,0,0,0,10.555,4.482,15.333,15.333,0,0,0,15-14.905,14.642,14.642,0,0,0-4.3-10.508,14.943,14.943,0,0,0-10.688-4.472Zm-109.964-25.22a20.96,20.96,0,0,0-.085,41.919h.213a21.145,21.145,0,0,0,20.889-21.071,21.289,21.289,0,0,0-20.971-20.849Zm110-175.748a86.735,86.735,0,0,0-.141,173.469h.252a86.878,86.878,0,0,0,86.68-86.558,87.019,87.019,0,0,0-86.571-86.911ZM10653.9,8126.3a15.068,15.068,0,0,0-10.6,4.5,14.813,14.813,0,0,0-4.394,10.592,15.291,15.291,0,0,0,14.922,14.892h.125a14.645,14.645,0,0,0,10.443-4.387,14.995,14.995,0,0,0-10.429-25.594Zm258.179-.007a14.992,14.992,0,0,0-.087,29.981l.271,0a15.308,15.308,0,0,0,14.923-14.625,14.652,14.652,0,0,0-4.127-10.569,15.289,15.289,0,0,0-10.665-4.786Zm-19.033-115.938a21.114,21.114,0,0,0-20.967,21.187,21.32,21.32,0,0,0,20.964,20.737h.165a21.24,21.24,0,0,0,20.8-21.051,21.02,21.02,0,0,0-20.947-20.872Zm-110-13.183a14.942,14.942,0,1,0-.007,29.884,14.842,14.842,0,0,0,10.668-25.319,15.079,15.079,0,0,0-10.647-4.565Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_162"
                          data-name="Path 162"
                          d="M10813.579,8194.478q-9.514,0-19.029-.027a4.748,4.748,0,0,1-3.406-1.015,2.705,2.705,0,0,1-.641-2.044c.063-1.928,1.39-2.886,4.057-2.928,1.607-.025,3.215-.034,4.822-.042q1.727-.009,3.45-.025a2.526,2.526,0,0,0,.955-.226c.127-.05.265-.1.448-.167l1.021-.353-.006-3.063c0-1.393-.01-2.828.011-4.26.021-1.38.418-3.7,2.854-3.738,2.558,0,2.971,2.429,2.988,3.877.016,1.381.012,2.762.008,4.2l0,3.619h18.923v-1.515c0-2.556.063-5.149.124-7.656a138.377,138.377,0,0,0-.306-17.333c-1.007-9.854-9.687-17.326-20.19-17.38-9.633-.049-18.58-.073-27.354-.073-8.854,0-17.576.027-25.918.078a20.535,20.535,0,0,0-20.48,20.5c-.06,4.9-.045,9.714-.031,14.805v.169q.01,3.435.014,6.943v1.515H10755l-.009-3.736c0-1.5-.013-2.982.017-4.467.044-2.217,1.132-3.539,2.909-3.539l.112,0c1.728.049,2.756,1.329,2.813,3.511.034,1.272.049,2.543.065,3.816.01.8.02,1.59.034,2.379a1.845,1.845,0,0,0,.337,1c.071.118.143.233.236.4l.438.768h.882c.78,0,1.579-.006,2.392-.012l.354,0c.959-.007,1.934-.015,2.92-.015,1.214,0,2.44.012,3.668.051a3.782,3.782,0,0,1,2.93,1.263,2.649,2.649,0,0,1,.48,2.239c-.339,1.691-1.326,2.445-3.2,2.449q-8.943.019-17.886.02-10.727,0-21.453-.036c-1.11,0-2.974-.3-2.977-2.258-.006-2.849-.065-5.749-.123-8.555-.165-7.836-.334-15.939.7-23.7,1.639-12.247,12.033-20.937,25.869-21.624.552-.028,1.1-.061,1.794-.1l4.627-.277-2.327-2.375c-8.07-8.236-11.4-17.4-10.171-28.012a31.779,31.779,0,0,1,11.807-21.487,32.773,32.773,0,0,1,43.974,2.12c11.16,11.015,14.785,31.323-.478,47.266l-2.068,2.16,2.966.39c.259.034.5.071.73.107l.122.017a14.089,14.089,0,0,0,1.587.182c16.063.655,26.714,11.4,27.133,27.384.183,6.907.12,13.949.059,20.759l-.034,4.037c-.025,3.208-.833,3.995-4.116,4Q10822.847,8194.478,10813.579,8194.478Zm-30.565-109.882a26.861,26.861,0,0,0-19.049,7.876,26.558,26.558,0,0,0-7.88,18.97,26.987,26.987,0,0,0,46.049,18.891,26.545,26.545,0,0,0,7.884-18.968,26.928,26.928,0,0,0-26.969-26.769Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Social Media Management</div>
                </div>
              </Link>

              <Link to="/digital-marketing/paid-marketing">
                <div
                  className={
                    accuratePath === "/digital-marketing/paid-marketing" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/search-engine-marketing-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/google-ad-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/bing-ad-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/facebook-ads-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/instagram-ads-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/twitter-ads-services" ||
                      accuratePath === "/twitter-ads" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/LinkedIn-ads-services" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/pinterest-ads-services" ||
                      accuratePath === "/youtube-ads" ||
                      accuratePath ===
                      "/digital-marketing/paid-marketing-services/youTube-ads-services"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="3"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="355.521"
                      height="300"
                      viewBox="0 0 355.521 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_23"
                        data-name="Group 23"
                        transform="translate(-11246.115 -7991.326)"
                      >
                        <path
                          id="Path_131"
                          data-name="Path 131"
                          d="M11540.131,8291.326c-.675,0-1.347-.012-2.021-.036-29.881-1.08-54.962-22.774-59.641-51.581a62.108,62.108,0,0,1,61.492-72.653c1.549,0,3.125.057,4.683.167,28.159,1.99,52.379,24.705,56.337,52.835a7.472,7.472,0,0,0,.616,1.965c.014.03.027.062.039.093v14.015c-.208.923-.41,1.851-.61,2.776-.46,2.112-.937,4.3-1.488,6.394C11592.632,8271.54,11567.093,8291.326,11540.131,8291.326Zm-.539-118.7a56.045,56.045,0,1,0,.087,0Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_132"
                          data-name="Path 132"
                          d="M11263.512,8272.808c-9.3,0-15.019-3.985-16.981-11.843a18.348,18.348,0,0,1-.4-4.256q-.032-124.655-.013-249.313c0-8.862,5.478-14.951,14.295-15.89a30.357,30.357,0,0,1,3.244-.159l96.839,0q96.836,0,193.676-.017c5.937,0,10.186,1.612,13.384,5.073,2.774,3,4.123,6.762,4.123,11.493v41.695q0,51.165-.015,102.33c0,1.627-.365,4.359-2.8,4.373-2.394,0-2.892-2.522-2.892-4.639q-.012-35.7-.007-71.393v-28.844h-314.391l0,203.361c0,8.941,3.48,12.426,12.412,12.427l202.48,0c.328,0,.657-.006.985-.013.3,0,.593-.011.889-.011a10.117,10.117,0,0,1,1.313.067,2.7,2.7,0,0,1,2.556,2.85c-.122,1.761-.826,2.476-2.595,2.642-.7.066-1.452.071-2.287.071l-109.021,0Q11310.911,8272.816,11263.512,8272.808Zm-.2-275.688c-7.961,0-11.686,3.7-11.724,11.635q-.018,3.8-.007,7.608l0,28.841h314.389l0-12.916c0-8.146.01-16.153-.011-24.16-.017-7.4-3.666-11-11.154-11q-12.39-.01-24.779-.009l-109.879,0Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_133"
                          data-name="Path 133"
                          d="M11329.808,8231.308c-1.676,0-3.33-.03-4.913-.092-6.4-.249-10.392-4.392-10.416-10.81-.03-8.617-.023-17.233-.017-25.97l.006-13.472-2.126-.354c-4.843-.8-8.136-2.929-10.366-6.683a6.417,6.417,0,0,0-4.79-2.688c-12.828-.9-21.986-9.681-22.787-21.841a23,23,0,0,1,19.355-24.094c3.952-.669,6.857-1.931,9.129-6.15,2.47-4.587,7.009-5.549,10.383-5.549q7.409,0,14.8.016,8.685.012,17.37.016c8.79,0,16.022-.019,22.764-.06,17.917-.108,32.85-3.453,45.652-10.227a92.268,92.268,0,0,0,10.631-6.832c3.368-2.426,6.982-5.559,7.235-12.051s6.775-12.193,13.956-12.193q.2,0,.4.006a14.2,14.2,0,0,1,14.034,13.568c.2,4.851.168,9.822.142,14.63-.01,1.776-.02,3.554-.019,5.331l0,14.548q.016,42.713,0,85.423c-.008,8.379-4.071,13.913-11.446,15.582a14.073,14.073,0,0,1-3.093.348,14.27,14.27,0,0,1-14.244-13.751,9.668,9.668,0,0,0-3.448-7.556c-11.487-10.167-25.83-16.406-42.634-18.544-5.562-.707-11.222-.885-16.7-1.056-2.873-.09-5.845-.183-8.741-.353-.217-.011-.426-.018-.624-.018-4.64,0-5.442,3.78-5.708,5.021-2.645,12.45-5.534,25.081-8.269,36.953-1.361,5.911-4.68,8.633-10.761,8.824C11332.944,8231.282,11331.341,8231.308,11329.808,8231.308Zm.179-5.746c1.139,0,2.135.039,3.046.12.314.028.615.042.9.042,3.429,0,5.546-1.919,6.3-5.705.8-4.007,1.717-8.076,2.607-12.012q.573-2.537,1.14-5.076l4.934-22.328h-27.478l-.672,1.506c-.068.153-.13.269-.179.365a3.394,3.394,0,0,0-.462,1.625q-.057,17.957-.083,35.907a5.68,5.68,0,0,0,1.46,4.109,5.494,5.494,0,0,0,4.128,1.555c.11,0,.543-.014.543-.014C11327.429,8225.61,11328.731,8225.562,11329.986,8225.562Zm115.829-147.487a8.632,8.632,0,0,0-8.672,7.246,17.273,17.273,0,0,0-.243,3.478v.174q-.009,58.035.022,116.074a16.83,16.83,0,0,0,.608,4.876,8.216,8.216,0,0,0,8.388,6.093h.2c5.169-.084,8.512-3.886,8.519-9.686q.028-22.776.012-45.551l0-56.807q0-2.4.013-4.8c.014-4.087.028-8.313-.057-12.483a8.478,8.478,0,0,0-7.93-8.575Q11446.233,8078.073,11445.815,8078.074Zm-79.647,96.751c25.1,0,44.483,5.565,61,17.512l4.032,2.917v-96.467l-4.033,2.918c-16.466,11.919-35.5,17.47-59.907,17.47,0,0-1.017,0-1.524-.007l-2.566-.024v55.69Zm-33.5-55.727q-9.577,0-19.1.038c-4.48.02-7.3,2.835-7.366,7.347-.041,3.027-.038,6.053-.034,9.079l0,2.561q0,14.244.011,28.488c.011,7.116,4.238,8.212,6.757,8.231,5.467.042,11.476.062,18.91.062q5.647,0,11.318-.009,5.7-.007,11.444-.01h2.543v-55.777Zm-35.068,11.437a19.083,19.083,0,0,0-13.387,6.21,16.758,16.758,0,0,0-4.1,12.319c.64,9.307,7.89,16.325,16.865,16.326h0q.45,0,.9-.025l2.408-.128v-34.864Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_134"
                          data-name="Path 134"
                          d="M11539.849,8270.322c-2.179-.1-2.724-2.582-2.8-4.651-.067-1.888-.728-2.972-1.962-3.235-1.254-.523-2.494-1.021-3.72-1.512-2.968-1.188-5.771-2.312-8.419-3.684a3.587,3.587,0,0,1-1.961-2,2.719,2.719,0,0,1,.391-2.087,2.286,2.286,0,0,1,2.133-1.233,5.784,5.784,0,0,1,2.517.7c1.575.794,3.191,1.5,4.9,2.253.808.353,1.648.722,2.536,1.121l3.586,1.615s0-7.639.007-9.435c.012-5.68.022-11.045-.084-16.409-.044-2.183-1.881-3.895-2.669-4.529a14.623,14.623,0,0,0-2.741-1.64c-.411-.205-.824-.407-1.217-.639-5.735-3.387-8.131-7.657-7.538-13.437.7-6.859,3.919-11.415,9.826-13.924l.267-.111c1.623-.683,4.339-1.823,4.244-5.843a3.877,3.877,0,0,1,.78-2.8,2.632,2.632,0,0,1,1.945-.666h.007c1.019,0,2.524.01,2.795,3.709.036.493.116,1.781.116,1.781l.095,1.437,1.279.658c.983.507,1.956.984,2.916,1.453a63.006,63.006,0,0,1,5.761,3.068,3.575,3.575,0,0,1,1.733,2.21,2.546,2.546,0,0,1-.485,2,2.274,2.274,0,0,1-1.947,1.166,5,5,0,0,1-2.435-.831c-.587-.353-1.187-.684-1.95-1.1l-1.286-.71-3.779-2.1v4.325c0,1.434-.007,2.832-.012,4.206-.018,4.19-.033,8.146.114,12.124.084,2.233,2.406,3.92,3.851,4.46,8.118,3.032,11.961,8.12,12.09,16.015.135,8.156-4.2,14.648-12.211,18.284a7.125,7.125,0,0,0-3.737,5.224c-.482,4.785-2.153,4.785-2.782,4.785Zm3.156-14.006,4.04-2.944c4.178-3.044,6.413-7.252,6.134-11.543a11.611,11.611,0,0,0-6.413-9.382l-3.761-2.054Zm-10.34-52.007c-3.038,2.524-4.6,5.719-4.294,8.764a8.338,8.338,0,0,0,4.721,6.491l3.74,2v-20.71Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_135"
                          data-name="Path 135"
                          d="M11419.706,8024l-136.12,0c-4.316-.044-4.332-1.852-4.34-2.721a2.243,2.243,0,0,1,.576-1.775,5.269,5.269,0,0,1,3.632-.994c9.506,0,60.154,0,60.154,0l41.722,0q17.84,0,35.677-.032c3.1,0,3.6.811,3.976,1.957a2.693,2.693,0,0,1-.232,2.291,2.629,2.629,0,0,1-1.9,1.2,10.555,10.555,0,0,1-1.483.084h0C11421.1,8024.022,11419.994,8024,11419.706,8024Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_136"
                          data-name="Path 136"
                          d="M11525.124,8033.655a12.428,12.428,0,0,1-8.534-21.156,11.964,11.964,0,0,1,8.573-3.623l.2,0A12.381,12.381,0,0,1,11533.9,8030a12.034,12.034,0,0,1-8.6,3.653Zm.154-18.953a6.781,6.781,0,0,0-5.2,2.126,5.937,5.937,0,0,0-1.376,4.737,8.6,8.6,0,0,0,2.5,4.512c.231.264.473.536.576.684l.768,1.1,1.344-.013c7.217-.067,8.007-4.646,8.012-6.611a6.286,6.286,0,0,0-6.46-6.539Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_137"
                          data-name="Path 137"
                          d="M11485.624,8033.655a12.4,12.4,0,0,1-8.551-21.172,12.005,12.005,0,0,1,8.551-3.608h.136a12.608,12.608,0,0,1,12.277,12.314,12.481,12.481,0,0,1-3.678,8.777,12.15,12.15,0,0,1-8.635,3.689Zm-.182-18.952a6.213,6.213,0,0,0-6.366,6.515c-.011,2.86,1.334,6.346,7.8,6.7l1.424.078.81-1.175c.12-.176.377-.467.623-.75a8.648,8.648,0,0,0,2.472-4.508,6.03,6.03,0,0,0-1.4-4.8,6.546,6.546,0,0,0-5.008-2.074Q11485.618,8014.7,11485.442,8014.7Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Paid Marketing</div>
                </div>
              </Link>

              <Link to="/digital-marketing/app-store-optimization">
                <div
                  className={
                    accuratePath === "/app-store-optimization" ||
                      accuratePath === "/digital-marketing/app-store-optimization"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="4"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="289.965"
                      height="290"
                      viewBox="0 0 289.965 290"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_38"
                        data-name="Group 38"
                        transform="translate(-11905.769 -7996.274)"
                      >
                        <path
                          id="Path_216"
                          data-name="Path 216"
                          d="M12028.982,8286.274q-41.241,0-82.479-.015c-20.829-.008-36.627-13.013-40.248-33.132a41.784,41.784,0,0,1-.459-7.257c-.023-66.783-.044-137.947-.006-209.191.011-20.326,13.318-36.37,33.115-39.921a43.273,43.273,0,0,1,7.589-.46q63.555-.022,127.122-.025,40.689,0,81.37.014c23.937.008,40.682,16.751,40.72,40.714.037,24.329.029,49.065.021,72.987q-.006,15.638-.008,31.275l.006,30.925q.012,36.667-.018,73.337c-.027,20.835-13.029,36.633-33.124,40.246a43.234,43.234,0,0,1-7.588.477Q12091.992,8286.271,12028.982,8286.274Zm20.618-283.3q-51.429,0-102.857.02c-20.476.007-34.238,13.754-34.249,34.207-.032,70.4-.032,140.437,0,208.168.011,20.433,13.789,34.168,34.288,34.175q42.214.018,84.438.018,61.683,0,123.36-.025a40.119,40.119,0,0,0,7.634-.527c16.244-3.115,26.757-16.27,26.782-33.513q.053-36.993.021-73.984l-.006-30.267,0-30.743q.006-36.421-.009-72.842c-.017-21.054-13.544-34.664-34.464-34.669Q12102.071,8002.979,12049.6,8002.979Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_217"
                          data-name="Path 217"
                          d="M12010.019,8066.9c-.251,0-.5,0-.755-.014-1.217-.055-4.044-.5-4.02-3.412.024-2.948,2.823-3.271,4.023-3.274q10.768-.021,21.533-.018l80.688,0q25.223,0,50.446.008c.26,0,1.2-.016,1.428-.016a5.857,5.857,0,0,1,1.616.166,3,3,0,0,1,2.372,3.286,3.068,3.068,0,0,1-2.661,3.107,8.269,8.269,0,0,1-1.884.159l-1.29-.009q-51.4.009-102.8.007h-47.52Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_218"
                          data-name="Path 218"
                          d="M12009.489,8222.384a9.761,9.761,0,0,1-1.088-.049c-2.036-.229-3-1.192-3.11-3.124-.071-1.186.14-2.83,2.771-3.437a7.267,7.267,0,0,1,1.573-.135c.259,0,.519.007.778.012.282,0,.563.01.843.01,32.585,0,150.017,0,150.017,0,6.036,0,6.091,2.157,6.12,3.315a2.589,2.589,0,0,1-.632,2.059c-.593.607-2.043,1.333-5.578,1.333h-150.016c-.291,0-.584.006-.877.012C12010.023,8222.38,12009.755,8222.384,12009.489,8222.384Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_219"
                          data-name="Path 219"
                          d="M12009.078,8144.637a4.724,4.724,0,0,1-1.055-.09c-2.472-.612-2.75-2.17-2.745-3.29a3.051,3.051,0,0,1,2.75-3.252,5.851,5.851,0,0,1,1.272-.1c.251,0,.5.006.758.011.282.007.563.014.843.014q28.378-.007,56.755,0l93.927,0c.275,0,.552-.006.829-.012.249-.005.5-.011.747-.011a7.56,7.56,0,0,1,1.115.066,3.208,3.208,0,0,1,3.1,3.31,3.32,3.32,0,0,1-3.1,3.315,7,7,0,0,1-.871.042l-.864-.006-66.155,0-86.186,0C12010,8144.623,12009.078,8144.637,12009.078,8144.637Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_220"
                          data-name="Path 220"
                          d="M11956.751,8086.132a22.444,22.444,0,1,1,.132,0Zm-.056-38.5a16,16,0,0,0-15.928,15.84,15.648,15.648,0,0,0,4.644,11.191,15.881,15.881,0,0,0,22.513-22.406,15.707,15.707,0,0,0-11.22-4.625Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_221"
                          data-name="Path 221"
                          d="M11956.706,8241.624a22.537,22.537,0,0,1-16.1-6.719,22.256,22.256,0,0,1-6.545-15.934,22.7,22.7,0,0,1,22.557-22.563h0a22.608,22.608,0,0,1,.152,45.216Zm-.035-38.492a16.054,16.054,0,0,0-15.9,15.8,15.539,15.539,0,0,0,4.532,11.2,15.878,15.878,0,1,0,11.482-27Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_222"
                          data-name="Path 222"
                          d="M11956.77,8163.888a22.614,22.614,0,1,1,22.472-22.659,22.532,22.532,0,0,1-22.34,22.659Zm-.038-38.515a16.086,16.086,0,0,0-15.962,15.747,15.582,15.582,0,0,0,4.54,11.226,15.948,15.948,0,0,0,11.244,4.828,15.9,15.9,0,0,0,.267-31.8Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">App Store Optimization</div>
                </div>
              </Link>
              <Link to="/digital-marketing/content-marketing">
                <div
                  className={
                    accuratePath === "/digital-marketing/content-marketing" ||
                      accuratePath === "/content-writing-services" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/web-page-writing" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/blog-writing" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/article-writing" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/guest-post-writing" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/social-media-post-writing" ||
                      accuratePath ===
                      "/digital-marketing/content-marketing/proofread"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="5"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="314.936"
                      height="300"
                      viewBox="0 0 314.936 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_25"
                        data-name="Group 25"
                        transform="translate(-13185.185 -7991.326)"
                      >
                        <path
                          id="Path_149"
                          data-name="Path 149"
                          d="M13261.61,8291.326q-28.648,0-57.291-.059a19.088,19.088,0,0,1-19.108-19.382c-.041-25.584-.027-51.08-.008-77.126.009-11.653,8.586-20.124,20.395-20.141q20.624-.029,41.253-.025l70.454.01v-23.918l-45.908.012q-13.875,0-27.752-.026c-10.517-.022-18.39-6.025-20.549-15.665a16.9,16.9,0,0,1-.329-3.686l-.015-23.072c-.024-31.871-.049-64.827.034-97.632.022-9.4,6.114-16.827,15.515-18.916a15.823,15.823,0,0,1,3.439-.324l.5,0a3.175,3.175,0,0,1,3.187,3,3.416,3.416,0,0,1-2.926,3.366c-9.7,1.51-13.309,5.7-13.31,15.464v95.767l9.838-7.941c3.081-2.485,6.013-4.849,8.938-7.222l23.472-19.036q16.132-13.087,32.269-26.17c1.761-1.427,2.937-2.091,3.7-2.091s1.924.679,3.672,2.138c0,0,40.3,33.628,54.389,45.374.563.47,1.144.919,1.776,1.407l.921.716,1.853,1.455s20.587-15.575,26.581-20.114q2.629-1.991,5.252-3.988s3.728-2.834,5.479-4.161c1.5-1.138,2.558-1.668,3.314-1.668a6.509,6.509,0,0,1,3.225,1.524q8.208,5.832,16.4,11.683l12.171,8.671c.627.447,1.271.868,2.021,1.355l1.178.773,4.51,2.986.24-5.4c.02-.434.039-.826.06-1.192.051-.923.088-1.639.088-2.354q.01-36.684,0-73.37c0-9.546-5.043-14.592-14.572-14.593,0,0-111.169,0-137.31-.006-1.8,0-3.127-.39-3.827-1.127a3.053,3.053,0,0,1-.661-2.335,2.991,2.991,0,0,1,2.75-2.925,9.691,9.691,0,0,1,1-.037l.884,0,74.868-.006q31.538,0,63.07.015c9.985.005,17.563,5.712,19.773,14.894a32.373,32.373,0,0,1,.64,7.367q.056,40.25.031,80.5v27.857h3.062q2.776,0,5.469-.016l.622,0q2.3-.009,4.557-.012c2.884,0,5.245.023,7.433.071a32.009,32.009,0,0,1,7.33.814c6.972,1.854,11.509,6.331,13.871,13.685.166.52.363,1.03.562,1.539l.034.089v92.351l-.229.645q-.423,1.188-.842,2.381a19.553,19.553,0,0,1-18.363,13.186c-2.587,0-4.114-1.17-4.187-3.209-.093-2.571,2.327-3.185,3.778-3.321,8.909-.839,13.429-5.771,13.433-14.659q.016-41.232,0-82.463c0-9-5.314-14.372-14.2-14.377q-35.347-.018-70.694-.018t-70.693.019c-8.811,0-14.093,5.284-14.132,14.119-.03,6.671-.023,13.346-.017,20.069l.006,11.433,2.5.466a20.183,20.183,0,0,1,12.964,7.689,19.959,19.959,0,0,1,4.022,12.736c-.066,9-.052,18.136-.04,26.977,0,0,.011,7.906.011,10.985v7.022l78.663,0c5.7,0,5.757,2.058,5.789,3.163a2.549,2.549,0,0,1-.646,1.959c-.872.9-2.742,1.413-5.132,1.413h-78.677v3.062q0,2.36.017,4.659c.019,3.5.037,6.8-.04,10.132-.023.991-.029,1.989-.034,2.987a44.7,44.7,0,0,1-.661,9.19,18.566,18.566,0,0,1-18.335,14.543Q13292.992,8291.323,13261.61,8291.326Zm-30.632-110.071q-12.554,0-25.108.017c-9.063.013-14.265,5.224-14.271,14.3q-.023,37.456,0,74.91c.008,9.154,5.316,14.406,14.564,14.407l58.129,0,58.129,0c9.243,0,14.545-5.354,14.547-14.687,0-20.871,0-73.341,0-73.341,0-10.775-4.768-15.584-15.459-15.592q-11.5-.01-23-.007l-34.039,0Zm74.86-125.739c-.149.092-.277.164-.388.228a7.171,7.171,0,0,0-.993.652q-8.694,7.044-17.357,14.121l-1.075.878c-15.682,12.785-31.9,26.006-48.09,38.67-6.918,5.411-9.575,11.195-8.885,19.341.854,10.061,5.4,14.549,14.754,14.552q13.611.006,27.226.006,20.077,0,40.156-.008c.757,0,1.512-.042,2.249-.085l.9-.049,2.534-.114.357-2.511c1.756-12.294,9.81-19.345,22.1-19.345q.674,0,1.354.031c3.1.136,6.42.2,10.437.2,2.785,0,5.571-.03,8.356-.061s5.531-.06,8.291-.06h13.732l1.547-4.8-75.337-62.782Zm104.992,20.7a6,6,0,0,0-3.721,1.464c-3.314,2.609-6.76,5.195-10.092,7.7l-.108.082q-2.364,1.772-4.722,3.555c-3.221,2.44-6.435,4.89-9.715,7.39l-7.393,5.63,7.642,6.367c4.985,4.162,9.647,8.052,14.459,11.93a8.863,8.863,0,0,0,5.335,1.591c2.944.042,5.891.054,8.833.054l9.392-.013h29.8V8118.9c0-1.2.006-2.367.012-3.511.018-3.184.033-6.191-.085-9.226a6.811,6.811,0,0,0-2.788-4.807q-9.193-6.628-18.432-13.2l-.642-.457q-7.151-5.108-14.293-10.227A5.933,5.933,0,0,0,13410.831,8076.214Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_150"
                          data-name="Path 150"
                          d="M13398.912,8222.581c-2.952,0-5.551-.036-7.948-.111-2.452-.077-3.34-1.023-3.392-3.617-.085-4.276-.071-8.647-.059-12.875l0-.685c0-1.622.01-3.244.008-4.867v-6.952l-8.935.008c-1.1,0-2.188,0-3.277-.011-7.225-.05-11.393-4.2-11.434-11.381l0-.383c-.029-5.2-.06-10.572.028-15.84.094-5.7,4.245-10.168,9.449-10.168.142,0,.283,0,.428.01,1.467.066,3,.1,4.549.1,11.827,0,23.47-1.979,34.729-3.893,4.471-.761,9.095-1.547,13.691-2.2,3.844-.545,7.721-1.193,11.468-1.82,3-.5,6.34-1.062,9.544-1.54a9.9,9.9,0,0,1,1.432-.115c1.764,0,3.491.335,3.574,4.343.042,2.026.036,4.092.03,6.089-.008,2.523-.016,5.132.071,7.734a6.1,6.1,0,0,0,3.57,5.185c3.784,1.376,3.744,2.239,3.68,3.668-.062,1.318-.109,2.359-4,3.256a5.313,5.313,0,0,0-.975.343c-.112.049-.254.11-.446.189l-1.906.774,0,7.569c0,4.059.009,8.081-.009,12.1-.024,5.239-1.664,5.239-3.563,5.239a15.2,15.2,0,0,1-2.525-.244c-5.671-.961-11.239-1.828-17.133-2.746l-.138-.021q-3.861-.6-7.8-1.222l-2.525-.4-1.289,3.677c-.361,1.025-.718,2.028-1.05,3.041l-1.02,3.095c-1.291,3.907-2.6,7.869-3.832,11.794-.618,1.965-1.642,2.775-3.534,2.8l-.884.01C13404.631,8222.549,13401.771,8222.581,13398.912,8222.581Zm-4.615-6.614h3.062c.509,0,1,.011,1.477.022.5.012.982.021,1.457.021a18.962,18.962,0,0,0,2.309-.121c1.263-.151,3.853-1.014,4.636-3.192,1.077-3,2.015-5.972,3.006-9.12,0,0,.67-2.123.988-3.117l1.076-3.374-18.01-2.976Zm-.218-54.4s0,5.579-.007,7.044c-.013,5.032-.023,9.785.1,14.654.056,2.332,2.419,4.514,4.5,4.906,3.393.644,6.841,1.172,10.175,1.683l.479.073q1.812.277,3.624.562c6.959,1.107,32.98,5.256,32.98,5.256v-42.433Zm-14.685.467c-1.716,0-3.037.038-4.284.121-2.065.135-4.648,2.323-4.719,4.685-.144,4.978-.145,10.053,0,15.515a5.291,5.291,0,0,0,4.559,4.6c1.294.074,2.676.107,4.482.107.784,0,1.574-.007,2.372-.012.835-.007,1.652-.013,2.482-.013h3.061v-24.972h-3.061c-.847,0-1.677-.008-2.492-.016C13380.957,8162.043,13380.172,8162.035,13379.395,8162.035Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_151"
                          data-name="Path 151"
                          d="M13369.816,8054.306a18.212,18.212,0,0,1-18.46-18.291,18.69,18.69,0,0,1,5.48-13.343,18.049,18.049,0,0,1,12.847-5.374h.155a18.91,18.91,0,0,1,18.522,18.566,18.519,18.519,0,0,1-18.5,18.441Zm-.181-30.309a12.106,12.106,0,0,0-8.546,3.7,11.652,11.652,0,0,0-3.311,8.459,12.107,12.107,0,0,0,11.93,11.673,11.836,11.836,0,0,0,11.949-11.989,11.617,11.617,0,0,0-11.893-11.843h-.13Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_152"
                          data-name="Path 152"
                          d="M13270.35,7997.738a3.109,3.109,0,0,1-2.229-.906,3.291,3.291,0,0,1-.926-2.373,3.013,3.013,0,0,1,3.248-3.082h.121a3.2,3.2,0,0,1,3.079,3.188,3.371,3.371,0,0,1-3.249,3.171Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_153"
                          data-name="Path 153"
                          d="M13451.973,8246.605a3.358,3.358,0,0,1-2.354-1.057,3.116,3.116,0,0,1-.945-2.2,3.207,3.207,0,0,1,3.334-3.1l.126,0a2.976,2.976,0,0,1,3,3.206,3.122,3.122,0,0,1-3.144,3.154Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_154"
                          data-name="Path 154"
                          d="M13247.9,8257.894c-2.769,0-3.016-3.227-3.025-4.215-.05-4.964-.037-10.07-.026-14.577q.009-3.192.011-6.386,0-3.149-.009-6.3c-.009-4.694-.018-9.546.021-14.358.01-1.3.325-4.317,3.016-4.317a5.887,5.887,0,0,1,2.668.771c13.86,7.358,25.411,13.55,36.354,19.486,1.777.965,2.857,2.217,2.886,3.347s-.981,2.445-2.71,3.506c-13.114,8.045-25,15.278-36.323,22.114A5.709,5.709,0,0,1,13247.9,8257.894Zm3.748-9.087,28.214-17.2-28.214-15.117Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Content Marketing</div>
                </div>
              </Link>

              <Link to="/digital-marketing/email-marketing">
                <div
                  className={
                    accuratePath === "/digital-marketing/email-marketing" ||
                      accuratePath === "/email-marketing-services" ||
                      accuratePath ===
                      "/digital-marketing/email-marketing/email-writing" ||
                      accuratePath ===
                      "/digital-marketing/email-marketing/email-automation-service" ||
                      accuratePath ===
                      "/digital-marketing/email-marketing/email-list-building-services" ||
                      accuratePath ===
                      "/digital-marketing/email-marketing/email-campaign-setup-and-management"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="6"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="303.053"
                      height="300"
                      viewBox="0 0 303.053 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_26"
                        data-name="Group 26"
                        transform="translate(-13831.982 -7991.326)"
                      >
                        <path
                          id="Path_155"
                          data-name="Path 155"
                          d="M13844.1,8291.326c-6.573,0-10.091-2-12.113-6.914V8120.348q2.212-2,4.419-4c4.014-3.64,8.105-7.349,12.175-10.923q4.963-4.362,9.973-8.67l.172-.148c4.6-3.971,9.347-8.078,13.982-12.211a9.17,9.17,0,0,0,2.8-6.307c.1-10.367.089-21.175.082-30.711q0-5.329,0-10.658c0-7.722,3.487-11.167,11.292-11.17l22.921-.008q13.279,0,26.557.041a10.5,10.5,0,0,0,7.441-2.681c10.487-9.222,20.624-17.975,32.788-28.458,2.4-2.068,4.726-3.118,6.91-3.118,2.167,0,4.361.979,6.709,2.993q6.93,5.945,13.823,11.933l.412.357c6.256,5.418,12.724,11.02,19.137,16.479a10.7,10.7,0,0,0,6.469,2.388c9.872.069,19.655.078,28.756.078l21.66,0c7.411.005,10.866,3.5,10.874,10.989l.006,5.25c.014,11.795.028,23.992-.047,36.07a8.4,8.4,0,0,0,3.218,6.929q9.233,7.925,18.421,15.9l.37.32q9.661,8.366,19.346,16.7a6.069,6.069,0,0,1,2.313,5.256v.277c-.071,51.109-.146,103.958.078,157.266a11.023,11.023,0,0,1-2.992,7.935,10.526,10.526,0,0,1-7.676,2.859c-15.2-.069-31.19-.1-51.841-.1q-14.435,0-28.872.014l-3.679,0q-12.592.007-25.184.012h-2.169a19.557,19.557,0,0,1-2.074-.073c-1.316-.146-2.891-.765-2.921-2.9a2.984,2.984,0,0,1,2.971-3.131,10.9,10.9,0,0,1,1.165-.049s1.262.014,1.526.014l111.62,0-104.554-89.786-11.185,7.139q-9.91,6.324-19.749,12.62a11.076,11.076,0,0,1-5.934,2.116,7.335,7.335,0,0,1-2.306-.378,16.306,16.306,0,0,1-3.62-1.764q-8.542-5.4-17.045-10.854l-7.6-4.856c-.7-.449-1.416-.878-2.156-1.325l-2.95-1.792-103.4,88.881h40.982q34.339,0,68.679.02a11.866,11.866,0,0,1,3.257.334,2.915,2.915,0,0,1-.609,5.646,23.361,23.361,0,0,1-3.062.136h-4.494q-13.03,0-26.058-.013t-26.056-.01c-21.332,0-37.613.036-52.79.116Zm-5.9-8.892,104.362-89.717-104.362-66.687Zm187.508-90.542,103.135,88.549V8125.978Zm-143.732-157.076c-.019.327-.041.628-.062.913-.049.673-.089,1.267-.089,1.86l0,25.376q0,39.891-.042,79.624a6.976,6.976,0,0,0,3.6,6.41c34.854,22.207,65.581,41.851,93.936,60.054a7.557,7.557,0,0,0,4.165,1.387,7.819,7.819,0,0,0,4.2-1.4c31.844-20.441,63.289-40.533,93.463-59.717a7.907,7.907,0,0,0,4.013-7.43c-.057-27.939-.054-56.276-.051-83.681l0-26.274h-202.967Zm209.63,107.75,34.724-22.214-34.724-30.084Zm-250.989-22.207,34.778,22.205v-52.343Zm109.731-95.1h66.31l-33.193-28.763Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_156"
                          data-name="Path 156"
                          d="M13983.451,8290.883a2.871,2.871,0,0,1-2.026-.889,3.119,3.119,0,0,1-.927-2.187,2.959,2.959,0,0,1,5.917-.033,3.127,3.127,0,0,1-.9,2.207,2.891,2.891,0,0,1-2.042.9Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_157"
                          data-name="Path 157"
                          d="M13959.539,8167.212a15.285,15.285,0,0,1-14.635-12.19c-.655-3.519-1.22-7.149-1.766-10.661l-.051-.321c-.243-1.564-.486-3.133-.74-4.7l-.462-2.861-2.883.3a16.5,16.5,0,0,1-1.74.1,10.1,10.1,0,0,1-8.479-4.1,5.783,5.783,0,0,0-4.386-1.928,5.437,5.437,0,0,0-.568.029c-3.8.414-7.614.963-11.165,1.494a10.555,10.555,0,0,1-1.567.119,8.413,8.413,0,0,1-8.528-6.8,135.33,135.33,0,0,1-2.231-13.647c-.464-4.242,2.863-8.507,7.266-9.312,1.485-.271,2.977-.5,4.468-.736,2.171-.338,4.393-.685,6.593-1.147a6.86,6.86,0,0,0,4.718-3.789c1.494-3.78,4.2-5.77,8.782-6.453,12.682-1.889,25.54-3.92,39.309-6.208a13.138,13.138,0,0,0,5.519-2.739q8.72-6.456,17.412-12.959l.109-.083q9.74-7.269,19.492-14.5a10.7,10.7,0,0,1,6.316-2.254c4.479,0,8.051,3.4,8.891,8.471.293,1.762.567,3.527.842,5.292l.376,2.413q1.513,9.6,3.015,19.194l.088.556c2.3,14.687,4.685,29.874,7.091,44.8.63,3.919-.064,7.3-1.955,9.519a8.464,8.464,0,0,1-6.7,2.811,15.228,15.228,0,0,1-4.438-.715q-5.706-1.745-11.405-3.5l-.148-.046c-10.262-3.159-20.874-6.424-31.354-9.517a23.916,23.916,0,0,0-6.152-.729c-.958-.031-1.931-.061-2.927-.141l-3.832-.309,1.063,7.264c.432,2.969.818,5.614,1.211,8.259.1.694.225,1.386.347,2.079a35.006,35.006,0,0,1,.514,3.634c.535,7.864-5.47,14.854-13.671,15.911A12.808,12.808,0,0,1,13959.539,8167.212Zm-11.645-31.962.481,3.018c.243,1.513.472,3.008.7,4.487l.04.262c.579,3.773,1.125,7.336,1.814,10.964a8.678,8.678,0,0,0,8.741,6.975,9.61,9.61,0,0,0,1.224-.078,8.534,8.534,0,0,0,7.7-9.38c-.389-3.755-.949-7.386-1.545-11.232l-.035-.223c-.234-1.523-.473-3.06-.7-4.619l-.448-3.074Zm70.729-76.638c-.222.117-.4.208-.563.285a7.3,7.3,0,0,0-1.2.695l-4.575,3.4c-10.246,7.615-20.841,15.49-31.208,23.309a6.327,6.327,0,0,0-2.142,5.6c.687,4.634,1.416,9.262,2.146,13.89l.055.353c.741,4.695,1.507,9.55,2.205,14.321a6.023,6.023,0,0,0,4.7,5.246c8.59,2.576,17.551,5.336,25.458,7.77l22.1,6.788-13.189-83.67Zm-90.017,38.74,5.381,33.866,43.837-6.9-5.353-33.876Zm-22.567,11.863,2.75,17.719,17.938-2.772-2.972-17.918Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_158"
                          data-name="Path 158"
                          d="M14051.9,8074.892a1.242,1.242,0,0,1-.937-.393,6.512,6.512,0,0,1-1.736-3.608c-.011-1.075,3.85-5.228,7.2-6.594l.58.357a10.536,10.536,0,0,1,1.868,1.327,4.992,4.992,0,0,1-.167,3.508c-1.142,1.764-3.271,3.294-5.331,4.774l-.3.217A2.054,2.054,0,0,1,14051.9,8074.892Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_159"
                          data-name="Path 159"
                          d="M14064.824,8120.492a4.033,4.033,0,0,1-1.087-.158c-2.221-.624-4.029-1.216-5.69-1.863-1.506-.586-2.084-1.489-2.095-1.92,0-2.3,1.2-3.976,2.854-3.976a2.565,2.565,0,0,1,.612.077,45.533,45.533,0,0,1,6.391,2.1,2.853,2.853,0,0,1,1.71,3.771A2.748,2.748,0,0,1,14064.824,8120.492Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_160"
                          data-name="Path 160"
                          d="M14056.784,8095.317c-1.087,0-1.837-.3-2.689-1.857a2.745,2.745,0,0,1-.1-2.336,2.519,2.519,0,0,1,1.528-1.5,32.205,32.205,0,0,1,7.52-1.449c.057,0,.115-.006.173-.006a2.5,2.5,0,0,1,1.785.793,3,3,0,0,1,.856,2.153c-.046,1.649-1.134,2.683-3.234,3.074-.755.139-1.522.324-2.292.513A16.353,16.353,0,0,1,14056.784,8095.317Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">E-mail Marketing </div>
                </div>
              </Link>

              <Link to="/digital-marketing/digital-branding">
                <div
                  className={
                    accuratePath === "/digital-marketing/digital-branding"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="7"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="289.965"
                      height="290"
                      viewBox="0 0 289.965 290"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_38"
                        data-name="Group 38"
                        transform="translate(-11905.769 -7996.274)"
                      >
                        <path
                          id="Path_216"
                          data-name="Path 216"
                          d="M12028.982,8286.274q-41.241,0-82.479-.015c-20.829-.008-36.627-13.013-40.248-33.132a41.784,41.784,0,0,1-.459-7.257c-.023-66.783-.044-137.947-.006-209.191.011-20.326,13.318-36.37,33.115-39.921a43.273,43.273,0,0,1,7.589-.46q63.555-.022,127.122-.025,40.689,0,81.37.014c23.937.008,40.682,16.751,40.72,40.714.037,24.329.029,49.065.021,72.987q-.006,15.638-.008,31.275l.006,30.925q.012,36.667-.018,73.337c-.027,20.835-13.029,36.633-33.124,40.246a43.234,43.234,0,0,1-7.588.477Q12091.992,8286.271,12028.982,8286.274Zm20.618-283.3q-51.429,0-102.857.02c-20.476.007-34.238,13.754-34.249,34.207-.032,70.4-.032,140.437,0,208.168.011,20.433,13.789,34.168,34.288,34.175q42.214.018,84.438.018,61.683,0,123.36-.025a40.119,40.119,0,0,0,7.634-.527c16.244-3.115,26.757-16.27,26.782-33.513q.053-36.993.021-73.984l-.006-30.267,0-30.743q.006-36.421-.009-72.842c-.017-21.054-13.544-34.664-34.464-34.669Q12102.071,8002.979,12049.6,8002.979Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_217"
                          data-name="Path 217"
                          d="M12010.019,8066.9c-.251,0-.5,0-.755-.014-1.217-.055-4.044-.5-4.02-3.412.024-2.948,2.823-3.271,4.023-3.274q10.768-.021,21.533-.018l80.688,0q25.223,0,50.446.008c.26,0,1.2-.016,1.428-.016a5.857,5.857,0,0,1,1.616.166,3,3,0,0,1,2.372,3.286,3.068,3.068,0,0,1-2.661,3.107,8.269,8.269,0,0,1-1.884.159l-1.29-.009q-51.4.009-102.8.007h-47.52Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_218"
                          data-name="Path 218"
                          d="M12009.489,8222.384a9.761,9.761,0,0,1-1.088-.049c-2.036-.229-3-1.192-3.11-3.124-.071-1.186.14-2.83,2.771-3.437a7.267,7.267,0,0,1,1.573-.135c.259,0,.519.007.778.012.282,0,.563.01.843.01,32.585,0,150.017,0,150.017,0,6.036,0,6.091,2.157,6.12,3.315a2.589,2.589,0,0,1-.632,2.059c-.593.607-2.043,1.333-5.578,1.333h-150.016c-.291,0-.584.006-.877.012C12010.023,8222.38,12009.755,8222.384,12009.489,8222.384Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_219"
                          data-name="Path 219"
                          d="M12009.078,8144.637a4.724,4.724,0,0,1-1.055-.09c-2.472-.612-2.75-2.17-2.745-3.29a3.051,3.051,0,0,1,2.75-3.252,5.851,5.851,0,0,1,1.272-.1c.251,0,.5.006.758.011.282.007.563.014.843.014q28.378-.007,56.755,0l93.927,0c.275,0,.552-.006.829-.012.249-.005.5-.011.747-.011a7.56,7.56,0,0,1,1.115.066,3.208,3.208,0,0,1,3.1,3.31,3.32,3.32,0,0,1-3.1,3.315,7,7,0,0,1-.871.042l-.864-.006-66.155,0-86.186,0C12010,8144.623,12009.078,8144.637,12009.078,8144.637Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_220"
                          data-name="Path 220"
                          d="M11956.751,8086.132a22.444,22.444,0,1,1,.132,0Zm-.056-38.5a16,16,0,0,0-15.928,15.84,15.648,15.648,0,0,0,4.644,11.191,15.881,15.881,0,0,0,22.513-22.406,15.707,15.707,0,0,0-11.22-4.625Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_221"
                          data-name="Path 221"
                          d="M11956.706,8241.624a22.537,22.537,0,0,1-16.1-6.719,22.256,22.256,0,0,1-6.545-15.934,22.7,22.7,0,0,1,22.557-22.563h0a22.608,22.608,0,0,1,.152,45.216Zm-.035-38.492a16.054,16.054,0,0,0-15.9,15.8,15.539,15.539,0,0,0,4.532,11.2,15.878,15.878,0,1,0,11.482-27Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_222"
                          data-name="Path 222"
                          d="M11956.77,8163.888a22.614,22.614,0,1,1,22.472-22.659,22.532,22.532,0,0,1-22.34,22.659Zm-.038-38.515a16.086,16.086,0,0,0-15.962,15.747,15.582,15.582,0,0,0,4.54,11.226,15.948,15.948,0,0,0,11.244,4.828,15.9,15.9,0,0,0,.267-31.8Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Digital Branding</div>
                </div>
              </Link>

              <Link to="/digital-marketing/analytics-and-reporting">
                <div
                  className={
                    accuratePath ===
                      "/digital-marketing/analytics-and-reporting"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="303.053"
                      height="300"
                      viewBox="0 0 303.053 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_26"
                        data-name="Group 26"
                        transform="translate(-13831.982 -7991.326)"
                      >
                        <path
                          id="Path_155"
                          data-name="Path 155"
                          d="M13844.1,8291.326c-6.573,0-10.091-2-12.113-6.914V8120.348q2.212-2,4.419-4c4.014-3.64,8.105-7.349,12.175-10.923q4.963-4.362,9.973-8.67l.172-.148c4.6-3.971,9.347-8.078,13.982-12.211a9.17,9.17,0,0,0,2.8-6.307c.1-10.367.089-21.175.082-30.711q0-5.329,0-10.658c0-7.722,3.487-11.167,11.292-11.17l22.921-.008q13.279,0,26.557.041a10.5,10.5,0,0,0,7.441-2.681c10.487-9.222,20.624-17.975,32.788-28.458,2.4-2.068,4.726-3.118,6.91-3.118,2.167,0,4.361.979,6.709,2.993q6.93,5.945,13.823,11.933l.412.357c6.256,5.418,12.724,11.02,19.137,16.479a10.7,10.7,0,0,0,6.469,2.388c9.872.069,19.655.078,28.756.078l21.66,0c7.411.005,10.866,3.5,10.874,10.989l.006,5.25c.014,11.795.028,23.992-.047,36.07a8.4,8.4,0,0,0,3.218,6.929q9.233,7.925,18.421,15.9l.37.32q9.661,8.366,19.346,16.7a6.069,6.069,0,0,1,2.313,5.256v.277c-.071,51.109-.146,103.958.078,157.266a11.023,11.023,0,0,1-2.992,7.935,10.526,10.526,0,0,1-7.676,2.859c-15.2-.069-31.19-.1-51.841-.1q-14.435,0-28.872.014l-3.679,0q-12.592.007-25.184.012h-2.169a19.557,19.557,0,0,1-2.074-.073c-1.316-.146-2.891-.765-2.921-2.9a2.984,2.984,0,0,1,2.971-3.131,10.9,10.9,0,0,1,1.165-.049s1.262.014,1.526.014l111.62,0-104.554-89.786-11.185,7.139q-9.91,6.324-19.749,12.62a11.076,11.076,0,0,1-5.934,2.116,7.335,7.335,0,0,1-2.306-.378,16.306,16.306,0,0,1-3.62-1.764q-8.542-5.4-17.045-10.854l-7.6-4.856c-.7-.449-1.416-.878-2.156-1.325l-2.95-1.792-103.4,88.881h40.982q34.339,0,68.679.02a11.866,11.866,0,0,1,3.257.334,2.915,2.915,0,0,1-.609,5.646,23.361,23.361,0,0,1-3.062.136h-4.494q-13.03,0-26.058-.013t-26.056-.01c-21.332,0-37.613.036-52.79.116Zm-5.9-8.892,104.362-89.717-104.362-66.687Zm187.508-90.542,103.135,88.549V8125.978Zm-143.732-157.076c-.019.327-.041.628-.062.913-.049.673-.089,1.267-.089,1.86l0,25.376q0,39.891-.042,79.624a6.976,6.976,0,0,0,3.6,6.41c34.854,22.207,65.581,41.851,93.936,60.054a7.557,7.557,0,0,0,4.165,1.387,7.819,7.819,0,0,0,4.2-1.4c31.844-20.441,63.289-40.533,93.463-59.717a7.907,7.907,0,0,0,4.013-7.43c-.057-27.939-.054-56.276-.051-83.681l0-26.274h-202.967Zm209.63,107.75,34.724-22.214-34.724-30.084Zm-250.989-22.207,34.778,22.205v-52.343Zm109.731-95.1h66.31l-33.193-28.763Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_156"
                          data-name="Path 156"
                          d="M13983.451,8290.883a2.871,2.871,0,0,1-2.026-.889,3.119,3.119,0,0,1-.927-2.187,2.959,2.959,0,0,1,5.917-.033,3.127,3.127,0,0,1-.9,2.207,2.891,2.891,0,0,1-2.042.9Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_157"
                          data-name="Path 157"
                          d="M13959.539,8167.212a15.285,15.285,0,0,1-14.635-12.19c-.655-3.519-1.22-7.149-1.766-10.661l-.051-.321c-.243-1.564-.486-3.133-.74-4.7l-.462-2.861-2.883.3a16.5,16.5,0,0,1-1.74.1,10.1,10.1,0,0,1-8.479-4.1,5.783,5.783,0,0,0-4.386-1.928,5.437,5.437,0,0,0-.568.029c-3.8.414-7.614.963-11.165,1.494a10.555,10.555,0,0,1-1.567.119,8.413,8.413,0,0,1-8.528-6.8,135.33,135.33,0,0,1-2.231-13.647c-.464-4.242,2.863-8.507,7.266-9.312,1.485-.271,2.977-.5,4.468-.736,2.171-.338,4.393-.685,6.593-1.147a6.86,6.86,0,0,0,4.718-3.789c1.494-3.78,4.2-5.77,8.782-6.453,12.682-1.889,25.54-3.92,39.309-6.208a13.138,13.138,0,0,0,5.519-2.739q8.72-6.456,17.412-12.959l.109-.083q9.74-7.269,19.492-14.5a10.7,10.7,0,0,1,6.316-2.254c4.479,0,8.051,3.4,8.891,8.471.293,1.762.567,3.527.842,5.292l.376,2.413q1.513,9.6,3.015,19.194l.088.556c2.3,14.687,4.685,29.874,7.091,44.8.63,3.919-.064,7.3-1.955,9.519a8.464,8.464,0,0,1-6.7,2.811,15.228,15.228,0,0,1-4.438-.715q-5.706-1.745-11.405-3.5l-.148-.046c-10.262-3.159-20.874-6.424-31.354-9.517a23.916,23.916,0,0,0-6.152-.729c-.958-.031-1.931-.061-2.927-.141l-3.832-.309,1.063,7.264c.432,2.969.818,5.614,1.211,8.259.1.694.225,1.386.347,2.079a35.006,35.006,0,0,1,.514,3.634c.535,7.864-5.47,14.854-13.671,15.911A12.808,12.808,0,0,1,13959.539,8167.212Zm-11.645-31.962.481,3.018c.243,1.513.472,3.008.7,4.487l.04.262c.579,3.773,1.125,7.336,1.814,10.964a8.678,8.678,0,0,0,8.741,6.975,9.61,9.61,0,0,0,1.224-.078,8.534,8.534,0,0,0,7.7-9.38c-.389-3.755-.949-7.386-1.545-11.232l-.035-.223c-.234-1.523-.473-3.06-.7-4.619l-.448-3.074Zm70.729-76.638c-.222.117-.4.208-.563.285a7.3,7.3,0,0,0-1.2.695l-4.575,3.4c-10.246,7.615-20.841,15.49-31.208,23.309a6.327,6.327,0,0,0-2.142,5.6c.687,4.634,1.416,9.262,2.146,13.89l.055.353c.741,4.695,1.507,9.55,2.205,14.321a6.023,6.023,0,0,0,4.7,5.246c8.59,2.576,17.551,5.336,25.458,7.77l22.1,6.788-13.189-83.67Zm-90.017,38.74,5.381,33.866,43.837-6.9-5.353-33.876Zm-22.567,11.863,2.75,17.719,17.938-2.772-2.972-17.918Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_158"
                          data-name="Path 158"
                          d="M14051.9,8074.892a1.242,1.242,0,0,1-.937-.393,6.512,6.512,0,0,1-1.736-3.608c-.011-1.075,3.85-5.228,7.2-6.594l.58.357a10.536,10.536,0,0,1,1.868,1.327,4.992,4.992,0,0,1-.167,3.508c-1.142,1.764-3.271,3.294-5.331,4.774l-.3.217A2.054,2.054,0,0,1,14051.9,8074.892Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_159"
                          data-name="Path 159"
                          d="M14064.824,8120.492a4.033,4.033,0,0,1-1.087-.158c-2.221-.624-4.029-1.216-5.69-1.863-1.506-.586-2.084-1.489-2.095-1.92,0-2.3,1.2-3.976,2.854-3.976a2.565,2.565,0,0,1,.612.077,45.533,45.533,0,0,1,6.391,2.1,2.853,2.853,0,0,1,1.71,3.771A2.748,2.748,0,0,1,14064.824,8120.492Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_160"
                          data-name="Path 160"
                          d="M14056.784,8095.317c-1.087,0-1.837-.3-2.689-1.857a2.745,2.745,0,0,1-.1-2.336,2.519,2.519,0,0,1,1.528-1.5,32.205,32.205,0,0,1,7.52-1.449c.057,0,.115-.006.173-.006a2.5,2.5,0,0,1,1.785.793,3,3,0,0,1,.856,2.153c-.046,1.649-1.134,2.683-3.234,3.074-.755.139-1.522.324-2.292.513A16.353,16.353,0,0,1,14056.784,8095.317Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Analytics And Reporting</div>
                </div>
              </Link>
            </Slider>

            {accuratePath === "/digital-marketing" ||
              accuratePath === "/digital-marketing/search-engine-optimization" ||
              accuratePath === "/seo-services" ||
              accuratePath ===
              "/digital-marketing/search-engine-optimization/on-page-SEO" ||
              accuratePath ===
              "/digital-marketing/search-engine-optimization/off-page-SEO" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/search-engine-optimization">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Search engine optimization
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/search-engine-optimization/on-page-SEO">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          On Page SEO
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/search-engine-optimization/off-page-SEO">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Off Page SEO
                        </div>
                      </Link>
                    </Tab>
                  </TabList>

                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Are you searching for the best search engine optimization services? Boost your website's visibility and rank higher on search engines with us!"
                          />
                        </MetaTags> */}
                        
                        {path === '/digital-marketing' && (
                          <Helmet>
                            <title>Digital Marketing & SEO Services to Grow Your Business| Kindlebit</title>
                            <meta
                              name="keyword"
                              content="digital marketing services, search engine optimization services"
                            />
                            <meta
                              name="description"
                              content="Boost your online presence with expert digital marketing services. Drive traffic and rankings with proven search engine optimization strategies."
                            />
                          </Helmet>
                        )}
                        {path === '/digital-marketing/search-engine-optimization' && (
                         <Helmet>
                         <title>Improve Your Site's Ranking | SEO & Marketing Experts</title>
                         <meta
                           name="keyword"
                           content="search engine optimisation companies, google search engine optimization, search engine optimization agencies, digital marketing company"
                         />
                         <meta
                           name="description"
                           content="Partner with leading search engine optimisation company for expert Google SEO services. Our company offers tailored SEO strategies to boost your online growth
"
                         />
                       </Helmet>
                        )}


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              {" "}
                              Search engine optimization
                            </div>
                            <div className="text-para">
                              Whether your website is new or old; to get traffic
                              on it, the website needs constant optimization
                              which is in line with the guidelines of search
                              engines else it won't rank higher. We, at
                              Kindlebit, scrutinize your website head-to-toe
                              ranging from a simple headline to all the URLs
                              suggesting changes that are in line with the
                              current changes that search engines roll out; so
                              you are assured of better results.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ahrefs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ahrefs.png"
                                      alt="Ahrefs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Search Console</Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Search Console"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEMRush</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Semrush_logo.svg.png"
                                      alt="Semrush"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Keyword Planner</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Keyword Planner"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Moz</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\moz.png"
                                      alt="Moz"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ubersuggest</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ubersuggest.png"
                                      alt="ubersuggest"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEO Quake</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\SEO-Quake-Toolbar.png"
                                      alt="SEO Quake"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Analytics</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Logo_Google_Analytics.svg.png"
                                      alt="Google Analytics"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">On Page SEO</div>
                            <div className="text-para">
                              On page SEO entails the elements which are visible
                              to the user as well as search engines. They
                              include the structure of URLs, UI and UX of the
                              website, and the content displayed on the website.
                              We audit the content of websites to find duplicate
                              and dead pages (if they exist), whether the URL
                              has elements which make it difficult for people
                              and search engine bots to understand, and whether
                              the website has a layout that is easier to
                              understand.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ahrefs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ahrefs.png"
                                      alt="Ahrefs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Search Console</Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Search Console"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEMRush</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Semrush_logo.svg.png"
                                      alt="Semrush"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Keyword Planner</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Keyword Planner"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Moz</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\moz.png"
                                      alt="Moz"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ubersuggest</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ubersuggest.png"
                                      alt="ubersuggest"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEO Quake</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\SEO-Quake-Toolbar.png"
                                      alt="SEO Quake"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Analytics</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Logo_Google_Analytics.svg.png"
                                      alt="Google Analytics"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Off Page SEO</div>
                            <div className="text-para">
                              For any website, the kind of websites that link to
                              it and the websites it links to affect the website
                              ranking something which all the search engines
                              assign credibility to any website. This is where
                              off page SEO comes in, by strategically selecting
                              the websites that are useful for your business and
                              disowning the ones that may be detrimental for
                              your business. Off page SEO helps improve the
                              authority of the website in the eyes of the search
                              engine which in turn leads to higher ranking in
                              search engine.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ahrefs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ahrefs.png"
                                      alt="Ahrefs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Search Console</Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Search Console"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEMRush</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Semrush_logo.svg.png"
                                      alt="Semrush"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Keyword Planner</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google_Icons-09-512.webp"
                                      alt="Google Keyword Planner"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Moz</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\moz.png"
                                      alt="Moz"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ubersuggest</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\ubersuggest.png"
                                      alt="ubersuggest"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>SEO Quake</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\SEO-Quake-Toolbar.png"
                                      alt="SEO Quake"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Google Analytics</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Logo_Google_Analytics.svg.png"
                                      alt="Google Analytics"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/social-media-management" ||
              accuratePath ===
              "/digital-marketing/social-media-management/facebook-marketing" ||
              accuratePath ===
              "/digital-marketing/social-media-management/instagram-marketing" ||
              accuratePath ===
              "/digital-marketing/social-media-management/twitter-marketing" ||
              accuratePath ===
              "/digital-marketing/social-media-management/linkedIn-marketing" ||
              accuratePath ===
              "/digital-marketing/social-media-management/pinterest-marketing" ||
              accuratePath ===
              "/digital-marketing/social-media-management/youTube-marketing" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/social-media-management">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Social Media Management
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/facebook-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Facebook Marketing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/instagram-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Instagram Marketing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/twitter-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Twitter Marketing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/linkedIn-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          LinkedIn Marketing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/pinterest-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Pinterest Marketing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/social-media-management/youTube-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          YouTube Marketing
                        </div>
                      </Link>
                    </Tab>
                  </TabList>

                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Collaborate with a leading social media marketing agency to boost your business's visibility. Explore our social media management services here."
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Expert Social Media Platforms Management & Handling Company</title>
                          <meta
                            name="keyword"
                            content="social media management, social media management companies, social media management platforms, social media handling, social media and management"
                          />
                          <meta
                            name="description"
                            content="Our social media management and content creation services include planning advanced social media management for effective management and marketing strategy.
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Social Media Management
                            </div>
                            <div className="text-para">
                              As Smartphone adoption has increased globally, so
                              has social media usage and hence brands are
                              leveraging the power of social media to connect
                              with their audience in a more personal manner
                              which further increases brand loyalty and creates
                              deeper and more meaningful connections between
                              brands and their consumers. Also, social media is
                              creating a level playing field for even smaller
                              brands as they are also using social media to
                              reach a new audience.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Facebook Marketing
                            </div>
                            <div className="text-para">
                              Facebook is the world’s largest social media
                              platform. With more than 2.8 billion active users
                              as per 2021 stat, this is a testament to how
                              important having a Facebook marketing strategy is.
                              Like any social media platform, Facebook allows
                              two kinds of posts on its platform: organic or
                              paid ads. With a Facebook Business Page, certain
                              tools are provided which give detailed insights
                              regarding the audience which includes page views,
                              post reach, likes, etc. using these tools helps
                              any business understand its audience better which
                              in turn translates to better products and services
                              for the customers.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Instagram Marketing
                            </div>
                            <div className="text-para">
                              Instagram, a highly visual and engaging platform,
                              has the highest number of active users globally.
                              The active age group of users active on Instagram
                              is lower than on Facebook and hence companies that
                              generally engage with younger audiences also
                              include Instagram as an important part of their
                              marketing strategy. Its organic content includes
                              posts, reels, stories, etc., similarly for paid
                              ads posts . To leverage the power of billion-plus
                              users, Instagram provides a business account that
                              allows tools like impressions, number of likes,
                              number of comments, etc. to be viewed by the
                              business thus they get insight regarding what kind
                              of content is working for them.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Twitter Marketing
                            </div>
                            <div className="text-para">
                              Twitter initially started as a micro blogging
                              platform where people could share real-time status
                              updates. Since Twitter allows discussion of niche
                              interests hence the conversations over here are
                              generally more engaging than on other social media
                              platforms. Twitter allows tweets including images,
                              videos, URLs, etc. on its platform as well as paid
                              twitter posts which can include sponsored tweets
                              that include all the above-mentioned features.
                              Twitter users generally tend to be more affluent
                              than the general population and the gender divide
                              is where Twitter generally has more male than
                              female users; hence companies prepare their
                              strategies accordingly.{" "}
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              LinkedIn Marketing
                            </div>
                            <div className="text-para">
                              LinkedIn is a professional networking site with
                              more than 875 million users globally. LinkedIn
                              provides a page feature which businesses can use
                              to create their presence on LinkedIn. Here
                              businesses can share case studies with their
                              audience, live events with lead gen forms, etc.
                              all these work as organic posts for your page in
                              case of paid ads, LinkedIn provides some extra
                              functionality over organic posts. People from
                              different walks of life use LinkedIn for different
                              purposes where it is used for finding jobs, hiring
                              a new employee, broadening professional
                              relationships, or learning and becoming certified
                              in a new skill. LinkedIn allows short posts which
                              can work as an update to your network, long-form
                              articles where different concepts can be
                              explained.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Pinterest Marketing
                            </div>
                            <div className="text-para">
                              Pinterest is a visual social media platform where
                              images and ideas are stored in the form of pins on
                              a board on any topic. Pinterest’s largest user
                              base comes from the USA and it boasts more than
                              400 million monthly active users on its platform.
                              Pinterest has an overwhelmingly higher number of
                              women than men in its user base; hence businesses
                              create their market strategy accordingly and
                              generally which cater to women are more likely to
                              use Pinterest as a part of their marketing effort.{" "}
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              YouTube Marketing
                            </div>
                            <div className="text-para">
                              YouTube is the second largest search engine behind
                              Google. This speaks volumes about the number of
                              people using YouTube for tutorials, streaming
                              music, game streaming, news, etc; this means that
                              it is a marketer’s gold mine. YouTube marketing
                              done effectively can lead to huge amounts of
                              traffic for the business which translates to
                              increased sales. As YouTube allows different kinds
                              of URLs in its description hence businesses can
                              put multiple URLs and therefore target different
                              kinds of audience members with a single video.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Buffer</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Buffer.png"
                                      alt="Buffer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hootsuite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hootsuite-Logo.png"
                                      alt="Hootsuite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Creator Studio</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\creator studio.png"
                                      alt="Creator Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Business suite</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Business Suite.png"
                                      alt="Business Suite"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Zapier</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Zapier.svg.png"
                                      alt="Zapier"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sprout Social</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sprout-social-logo-new.png"
                                      alt="Sprout Social"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Canva</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Canva.png"
                                      alt="Canva"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/paid-marketing" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/search-engine-marketing-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/google-ad-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/bing-ad-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/facebook-ads-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/instagram-ads-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/twitter-ads-services" ||
              accuratePath === "/twitter-ads" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/LinkedIn-ads-services" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/pinterest-ads-services" ||
              accuratePath === "/youtube-ads" ||
              accuratePath ===
              "/digital-marketing/paid-marketing-services/youTube-ads-services" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Paid Marketing Services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/search-engine-marketing-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Search Engine Marketing Services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/google-ad-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Google ad services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/bing-ad-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Bing ad services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/facebook-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Facebook ads services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/instagram-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Instagram ads services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/twitter-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Twitter ads services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/LinkedIn-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          LinkedIn ads services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/pinterest-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Pinterest ads services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/paid-marketing-services/youTube-ads-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          YouTube ads services
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Amplify your online success with Kindlebit's expert paid marketing services. Increase traffic, sales, and brand growth today!."
                          />
                        </MetaTags> */}

                        <Helmet>
                          <title>Top PPC Advertising Services | Google Adwords Campaign Management</title>
                          <meta
                            name="keyword"
                            content="pay per click campaign, pay per click advertising, google paid advertising, pay per click advertising companies, google adwords pay per click"
                          />
                          <meta
                            name="description"
                            content="Boost business with our top PPC advertising and expert Google AdWords campaign management. Drive traffic with optimized pay per click advertising solutions.
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Paid Marketing Services
                            </div>
                            <div className="text-para">
                              Paid marketing encompasses money which is spent on
                              advertising on different social media platforms
                              and search engines with various objectives as
                              defined by the organization’s goals for itself.
                              However, these goals can be fulfilled much earlier
                              with the help of targeted ads that are run across
                              various platforms which leads to higher
                              conversion, higher return on ad spent (ROAS), and
                              better return on investment (ROI).
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Search Engine Marketing Services
                            </div>
                            <div className="text-para">
                              The maximum amount of traffic that flows to any
                              website is directly from search engines; hence it
                              is important for websites to rank higher on search
                              engines. Though it is really difficult for certain
                              keywords that businesses are targeting and often
                              the results of the SEO efforts take months if not
                              years to materialize. Search engine marketing
                              (SEM) is where paid results are displayed on a
                              search engine results page (SERP) as they are
                              known to drive traffic to a product or service
                              easily.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Google ad services
                            </div>
                            <div className="text-para">
                              Google is the biggest search engine across the
                              globe. The highest volume of searches happens on
                              this platform and advertisers, and marketers are
                              fully aware of this; hence they use Google to get
                              the maximum result for their marketing efforts.
                              These ads come in formats such as text-based,
                              responsive ads, image ads, app promotion ads,
                              video ads, product listings , and call-only ads.
                              All of these assist users to get the right product
                              for them, and businesses can make revenue from
                              these users.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Bing ad services
                            </div>
                            <div className="text-para">
                              Bing holds the second-highest position in search
                              engines. It derives its highest traffic share from
                              China and is the default search engine for most of
                              Windows users. Like Google, Bing works on similar
                              algorithms which index pages, and like Google it
                              allows ads to be displayed on the search engine
                              results page. For businesses exclusively targeting
                              Chinese buyers, Bing is a better option than
                              Google as Bing gets more traffic from Chinese
                              sites..
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Facebook ads services
                            </div>
                            <div className="text-para">
                              Facebook boasts the greatest number of users
                              globally which has allowed it to provide the user
                              base that it has to advertisers. The initial
                              amount of money spent on Facebook to get results
                              is significantly lower than the amount required to
                              spend on traditional media channels and that has
                              shifted how brands spend on a marketing budget.
                              Facebook also provides the most comprehensive tool
                              to target audience in the form of Facebook Ads
                              Manager which allows for extremely granular
                              control in the form of the amount of budget you
                              want to spend, your ad placements, etc. thus
                              businesses get a lot of value from it.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Instagram ads services
                            </div>
                            <div className="text-para">
                              Instagram, a highly visual and engaging platform
                              initially started as a photo-sharing platform.
                              Instagram also has more than 1.3 billion active
                              users as per the 2021 stat. Instagram’s user base
                              primarily includes millennials and gen z, so the
                              content over there generally resonates with people
                              of this age group. Though for businesses, these
                              age groups are a gold mine because they are the
                              ones who are the most active spenders online, and
                              hence businesses have been quite active in
                              spending on Instagram. Also, as Instagram comes
                              under Facebook’s family of apps hence advertisers
                              get access to Facebook Ads Manager and they can
                              leverage it to attract the right kind of audience
                              for their product or service.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Twitter ads services
                            </div>
                            <div className="text-para">
                              Twitter started as a micro blogging platform where
                              status could be updated in real-time. It boasts a
                              user base of more than 400 million globally.
                              Twitter is uniquely positioned in the social media
                              platforms as its user base is generally
                              university-level graduates which means that
                              Twitter has people that are rather working at
                              higher positions in various organizations, and
                              hence businesses targeting high ticket sales are
                              generally much better to spend their marketing
                              efforts on Twitter as on it chances of conversion
                              are much higher than other platforms.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              LinkedIn ads services
                            </div>
                            <div className="text-para">
                              LinkedIn is a professional social media network
                              where executives, recruiters, employees, job
                              seekers, etc. connect to create meaningful
                              relationships which could be leveraged to hire
                              talent for various open positions. LinkedIn is
                              also used by businesses for creating business
                              relationships between companies thus leading to
                              great B2B conversions. LinkedIn provides
                              comprehensive tools for recruiters in the form of
                              LinkedIn jobs, Inmail which allows people to mail
                              to other people not in their connection. LinkedIn
                              like Twitter has a user base which is university
                              educated and hence here also high-ticket sales
                              conversion is much easier.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Pinterest ads services
                            </div>
                            <div className="text-para">
                              Pinterest is a visually appealing platform where
                              boards on different topics are created and pins on
                              these boards are added for things that inspire
                              people. Pinterest has an overwhelmingly greater
                              number of women than men as its audience; hence
                              advertisers whose primary audience is women are
                              much more likely to use Pinterest in their
                              marketing strategy. In the case of Pinterest,
                              sponsored boards or pins are created by
                              advertisers with a link added to the website which
                              leads to conversion.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              YouTube ads services
                            </div>
                            <div className="text-para">
                              YouTube is the biggest streaming platform and the
                              second largest search engine just after Google. It
                              also has a monthly active user base of more than 2
                              billion users which means it is great for
                              advertisers to market their products. YouTube
                              comes under the Google family of apps. Hence, they
                              have quite comprehensive data about what people
                              search on the internet and hence ads shown on the
                              platform are generally quite well-targeted.
                              YouTube provides many different types of ad
                              formats and placements for advertisers to take
                              advantage of this.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>Facebook Ads Manager</Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Facebook Ads manager.png"
                                      alt="Facebook ads manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        AdEspresso (for Facebook and Instagram
                                        Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src="\assets\images\software-icons\Adespresso.png"
                                      alt="Adespresso"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Ads</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\g-ads-logo.jpg"
                                      alt="Google Ads Manager"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Google Data Studio(for Google Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title=""
                                      src="\assets\images\software-icons\Google Data Studio.png"
                                      alt="Google Data Studio"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        Microsoft Ads Editor (for Bing Ads)
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Microsoft Ads Editor (for Bing Ads)"
                                      src="\assets\images\software-icons\Microsoft Ad Manager.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/app-store-optimization" ||
              accuratePath === "/digital-marketing/app-store-optimization" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/app-store-optimization">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          App store optimization
                        </div>
                      </Link>
                    </Tab>
                  </TabList>

                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Kindlebit's App Store Optimization services help you increase your app's exposure and downloads. Contact us to improve rankings and user engagement."
                          />
                        </MetaTags> */}

                        <Helmet>
                          <title>Top App Store Optimization Services | Leading ASO Company</title>
                          <meta
                            name="keyword"
                            content="app store optimization, app store optimization agency, app store optimization company, app store optimization services"
                          />
                          <meta
                            name="description"
                            content="Maximize app visibility with our top app store optimization services. As a leading app store optimization agency and company, we drive app growth with proven ASO strategies
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              App store optimization
                            </div>
                            <div className="text-para">
                              Smartphones rely heavily on their respective app
                              stores for the apps that can be downloaded on them
                              and hence having the right kind of description for
                              your app is imperative. The right kind of
                              description which targets the kind of keywords
                              that are important for your app means that it
                              could rank higher thus leading to higher downloads
                              which boosts your revenue.
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/content-marketing" ||
              accuratePath === "/content-writing-services" ||
              accuratePath ===
              "/digital-marketing/content-marketing/web-page-writing" ||
              accuratePath ===
              "/digital-marketing/content-marketing/blog-writing" ||
              accuratePath ===
              "/digital-marketing/content-marketing/article-writing" ||
              accuratePath ===
              "/digital-marketing/content-marketing/guest-post-writing" ||
              accuratePath ===
              "/digital-marketing/content-marketing/social-media-post-writing" ||
              accuratePath ===
              "/digital-marketing/content-marketing/proofread" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/content-marketing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Content writing services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/web-page-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Web page writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/blog-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Blog writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/article-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Article writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/guest-post-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Guest post writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/social-media-post-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Social media post writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/content-marketing/proofread">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Proofread
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Create a compelling brand story and engage your audience! Learn how our content marketing services can help you boost your business growth."
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Professional Website Content Writing Services | SEO Content & Blog Writing Experts</title>
                          <meta
                            name="keyword"
                            content="website content writing, seo website content writer, content writing services, website content writer, blog writing service"
                          />
                          <meta
                            name="description"
                            content="Boost your online presence with our website content writing services. Our expert writers deliver high-quality content writing services for impactful results.
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Content writing services
                            </div>
                            <div className="text-para">
                              Any marketing campaign is as strong as the content
                              which is encompassed in it. As often said in
                              marketing, “Content is King!” is now more
                              important than ever. Having content that aligns
                              with your business goals while being congruous to
                              the audience’s views is the type of content that
                              performs and helps land traffic which further
                              leads to sales.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Web page writing
                            </div>
                            <div className="text-para">
                              The heart of every website is the kind of content
                              that is present on its pages. The content should
                              be easy to understand yet should follow a language
                              that intrigues the users as that drives engagement
                              on the website. Also, the content should follow
                              the language style of similar websites in the
                              niche. For example, an informative website
                              designed to provide tutorials shouldn’t have a
                              content style similar to e-commerce websites and
                              vice versa. An experienced content writer can help
                              you achieve that exactly as they know what style
                              of content works on which type of niche.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Blog writing</div>
                            <div className="text-para">
                              Blogs are a great way for businesses to build
                              connections with their prospective clients.
                              Businesses use blogs to announce feature rollouts,
                              changes happening in the industry, changes
                              happening in the organization, tips, and tricks,
                              etc. this help address some issues of website
                              visitors directly which in turn helps increase the
                              credibility of the website and great blog entries
                              are helpful in SEO as well. However, writing great
                              blogs is easier said than done they require
                              comprehensive research, and content that gathers
                              people’s attention easily. For a seasoned blog
                              writer, this is an easy task however for a novice
                              it can be quite daunting.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Article writing
                            </div>
                            <div className="text-para">
                              Articles like blogs are long-form content however
                              as a rule of thumb articles are a much longer form
                              of content than blogs. They provide businesses an
                              opportunity to market their products and services
                              directly as they are detail-oriented and hence
                              provide a lot of information to the users. Thus,
                              creating a rapport among the visitors of the
                              website. Having great articles on the website also
                              establishes the business or individual as an
                              expert in the field which in turn helps improve
                              the website’s credibility thus leading to higher
                              SEO ranking as search engines award higher ranking
                              to the ones that establish themselves as experts
                              in any field.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Guest post writing
                            </div>
                            <div className="text-para">
                              An important part of improving a website's ranking
                              is having mentions on other websites for your
                              website. As that has been known to boost rankings
                              and this is where guest posts come in. Guest posts
                              allow websites to get a mention from other
                              websites which leads to an increase in credibility
                              thus improved SEO ranking. Guest posts have been
                              proven to improve traffic as well as SEO in the
                              long run. They are also a way to tap into the
                              website’s audience and discover new demographics
                              which could be targeted to something which wasn’t
                              happening on their own website.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Social media post writing
                            </div>
                            <div className="text-para">
                              Social media has changed how people interact with
                              each other. Initially started as a way to get
                              connected with your old friends, status updates,
                              job search, etc. have evolved over the years and
                              are now comprehensively used by businesses as an
                              important part of their marketing strategy. As
                              their user base has increased; creating content
                              that is engaging for the public is now more
                              difficult than ever. This has led to specialized
                              content writers who write great copy for social
                              media which helps businesses land new followers,
                              leads, etc.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Proofread</div>
                            <div className="text-para">
                              Any piece of content is as strong as the first
                              revision. This has been proven true time and again
                              and hence getting a good proofread on the topic
                              can help generate new ideas, avoid embarrassment,
                              improve grammar, etc. all these are instrumental
                              in having a great copy that resonates with the
                              readers. A well-read proofreader can help improve
                              content quality thus helping businesses and users
                              as well.{" "}
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Proofread</div>
                            <div className="text-para">
                              Any piece of content is as strong as the first
                              revision. This has been proven true time and again
                              and hence getting a good proofread on the topic
                              can help generate new ideas, avoid embarrassment,
                              improve grammar, etc. all these are instrumental
                              in having a great copy that resonates with the
                              readers. A well-read proofreader can help improve
                              content quality thus helping businesses and users
                              as well.{" "}
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Grammarly</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Grammarly_logo.svg.png"
                                      alt="Grammarly"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Copyscape</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\copyscape-group-buy-tool.png"
                                      alt="copyscape"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>The Saurus</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Thesaurus.com_logo.svg.png"
                                      alt="Saurus"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Google Docs</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Google-Docs-Header-1280x720-1-1024x576.png"
                                      alt="Google-Docs"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Surfer SEO</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\surfer-logo.jpg"
                                      alt="Surfer"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Coschedule</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\CoSchedule.png"
                                      alt=""
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/email-marketing" ||
              accuratePath === "/email-marketing-services" ||
              accuratePath ===
              "/digital-marketing/email-marketing/email-writing" ||
              accuratePath ===
              "/digital-marketing/email-marketing/email-automation-service" ||
              accuratePath ===
              "/digital-marketing/email-marketing/email-list-building-services" ||
              accuratePath ===
              "/digital-marketing/email-marketing/email-campaign-setup-and-management" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/email-marketing/email-marketing-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Email Marketing Services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/email-marketing/email-writing">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Email writing
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/email-marketing/email-automation-service">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Email automation service
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/email-marketing/email-list-building-services">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Email list-building services
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/digital-marketing/email-marketing/email-campaign-setup-and-management">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Email Campaign Setup and Management
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Boost your email marketing with Kindlebit. Our expert team creates targeted campaigns that engage your audience and drive results. Contact us today!."
                          />
                        </MetaTags> */}

                        <Helmet>
                          <title>Kindlebit: Email Marketing & Marketing Automation Platform</title>
                          <meta
                            name="keyword"
                            content="best emailing services, email marketing services, email marketing campaign, best email marketing service, email marketing agency"
                          />
                          <meta
                            name="description"
                            content="Discover emailing services with our powerful automation platform for email marketing. Leverage AI-driven email marketing campaigns for faster, efficient growth.
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Email Marketing Services
                            </div>
                            <div className="text-para">
                              Email is known as a marketer’s gold mine. Email
                              still has a very high ROI and that is why
                              marketers frequently use email as an important
                              part of their marketing strategy. In fact, a case
                              study by the content marketing institute 2020
                              shows that 81% of B2B find that email newsletters
                              are the most used form of content marketing
                              strategy. This, in itself, is a testament to the
                              importance of email marketing
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Email writing</div>
                            <div className="text-para">
                              An integral part of any email marketing campaign
                              is the email copy that has been written. A great
                              email shall intrigue the users, lead to a higher
                              open rate, and thus further leads to conversion.
                              Further, a great email campaign helps bring in new
                              clients as well as retain old clients,
                              particularly in B2B marketing.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Email automation service
                            </div>
                            <div className="text-para">
                              For a great email campaign to function, mail
                              automation is the need of the hour. Setting up
                              personalized emails depending upon the actions
                              taken by visitors of the website allows businesses
                              to foster great business relations and further
                              create them into loyal paying customers in the
                              long term. It addresses businesses' need for
                              keeping staff to send personalized messages, thus
                              assisting in decreasing costs in the long run as
                              well.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Email list-building services
                            </div>
                            <div className="text-para">
                              Any email marketing campaign requires a strong
                              email list for it to be profitable to the
                              business. By carefully setting up newsletter
                              offers, websites build a list of prospective
                              clients who could further move in the sales
                              funnel. Furthermore, emails of people who had any
                              kind of query regarding your business through any
                              channel are added to the email list as they were
                              already part of your marketing funnel and might be
                              nudged further through the funnel by receiving
                              frequent emails.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Email Campaign Setup and Management
                            </div>
                            <div className="text-para">
                              After the SMART goals for the campaign have been
                              discussed, post this exercise, the email campaign
                              is set up considering it. This campaign contains
                              triggers that are used while sending different
                              kinds of personalized emails, different templates
                              of emails that could be sent, etc. any campaign
                              would not do justice to itself if it were not
                              maintained. Through the curation of data in the
                              campaign, marketers get a better idea regarding
                              what kind of content is performing and what isn’t.
                              This allows marketers the flexibility of changing
                              campaigns to achieve better success down the road.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/digital-branding" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/digital-branding">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Digital Branding
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Build and monitor the online reputation of your industry to boost engagement and sales and enhance brand loyalty and credibility. Find out more!."
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Digital Brand Management - Crafting Your Online Impact</title>
                          <meta
                            name="keyword"
                            content="online brand management, branding and marketing, digital marketing branding services, digital branding companies"
                          />
                          <meta
                            name="description"
                            content="Digital brand management boosts online presence, visibility, and growth. Our digital marketing services, and top digital branding companies drive success.
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Digital Branding
                            </div>
                            <div className="text-para">
                              Our digital branding services refer to the
                              techniques and strategies used to establish and
                              promote a brand online. These services include a
                              wide range of activities, such as creating a brand
                              identity, developing a website, designing social
                              media profiles, producing content, and managing
                              online reputation.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/digital-marketing/analytics-and-reporting" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/digital-marketing/analytics-and-reporting">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                          Info
                          Graphic
                        >
                          Analytics And Reporting
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        <Helmet>
                          <title>Comprehensive Marketing Data Analysis | Analytics Reports</title>
                          <meta
                            name="keyword"
                            content="marketing data analysis, data analytics report, data analysis and reporting, analytics and reporting"
                          />
                          <meta
                            name="description"
                            content="Insights with expert marketing data analysis and reporting. Our data reports provide in-depth analytics and reporting to drive smarter business decisions
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Analytics And Reporting
                            </div>
                            <div className="text-para">
                              Our analytics and reporting services refer to the
                              techniques and tools used to collect and analyze
                              data in order to gain insights into business
                              performance and make data-driven decisions. These
                              services include a range of activities, such as
                              collecting data from various sources, creating
                              reports and dashboards, and providing analysis
                              based on the data.
                            </div>
                          </div>
                          <div className="ipc">
                            <div className="ipc-soft-icon">
                              <div className="ipc-si-heading">
                                softwares we work on
                              </div>
                              <div className="ipc-si-head">
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Hubspot</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Hubspot.png"
                                      alt="Hubspot"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sendinblue</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\sendinblue.png"
                                      alt="Sendinblue"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Mailchimp</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\Mailchimp-logo.png"
                                      alt="Mailchimp"
                                    />
                                  </OverlayTrigger>
                                </span>
                                <span className="ipc-si-head-inner">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>klaviyo</Tooltip>}
                                  >
                                    <img
                                      src="\assets\images\software-icons\klaviyo-vector-logo.png"
                                      alt="klaviyo"
                                    />
                                  </OverlayTrigger>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="ipc"></div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => naviagte("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
          </div>
        </section>
      </main>

      {/* Contact modal */}
      {commonModal && (
        <ContactModal
          commonModal={commonModal}
          setCommonModal={setCommonModal}
        />
      )}
    </>
  );
}
export default Marketing;
